export default {
  nav: {
    home: 'Home',
    howItWorks: 'How It Works',
    forArchitects: 'For Architects',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    untukArsitek: 'For Architects',
    untukKlien: 'For Clients',
    masuk: 'Sign in',
    mulaiProyek: 'Start Free Project',
    dasbor: 'Dashboard',
    keluar: 'Sign out'
  },
  landing: {
    eyebrow: '1.4k+ IAI Licensed Architects',
    hero: {
      title: 'Build Your Dream Design, Effortlessly',
      subline:
        'Compare top architect bids, manage your project with precision, and build your dream with rumantra.',
      cta: 'Start Free Project',
      learnMore: 'Learn how it works',
      microcopy: 'Free for clients · No registration fees'
    },
    trust: {
      rating: '4.9/5',
      desc: 'from 1,200+ user reviews'
    },
    jelajahi: {
      trending: 'Project List',
      searchPlaceholder: 'Search projects, architects, or design styles...',
      filterAll: 'All',
      filterHunian: 'Residential',
      filterKomersil: 'Commercial',
      filterIndustrial: 'Industrial',
      filterLainnya: 'Other',
      emptyState: 'No projects available yet.',
      addDesign: 'Add Design'
    },
    starters: {
      eyebrow: 'Start Here',
      title: 'What are you building?',
      subline: 'Pick a starting point and we will shape the brief around it.'
    },
    howItWorks: {
      eyebrow: 'How It Works',
      step1Title: 'Post Your Project Brief',
      step1Desc:
        'Describe your needs — area, budget, design style. Our AI helps you craft a professional brief.',
      step2Title: 'Receive & Compare Bids',
      step2Desc:
        'IAI licensed architects submit bids. Compare prices, timelines, and portfolios side by side.',
      step3Title: 'Build with Confidence',
      step3Desc:
        'Your chosen architect gets to work. Funds release per milestone — your project stays on track.'
    },
    why: {
      label: 'Designed for your peace of mind',
      card1Title: 'IAI verified architects',
      card1Desc: 'Only architects with official licenses and verified portfolios can join.',
      card2Title: 'Transparent pricing',
      card2Desc: 'Compare prices across studios apples-to-apples with no hidden fees.',
      card3Title: 'Secure payments',
      card3Desc: 'Your funds are held safely in rumantra escrow until each phase is approved.',
      card4Title: 'Centralised communication',
      card4Desc: 'All revisions, documents, and chats are neatly stored in one project dashboard.',
      card5Title: 'Diverse expertise',
      card5Desc:
        'From minimalist homes to sports stadiums, specialists are available for everything.',
      card6Title: 'All across Indonesia',
      card6Desc: 'Find local talent in your city or renowned architects from the capital.'
    },
    cta: {
      title: 'Ready to Start Your Dream Project?',
      subline: 'Join thousands of clients building confidently with rumantra.',
      primary: 'Start Free Project',
      secondary: 'Join as an Architect'
    },
    v2: {
      nav: {
        howItWorks: 'How it works',
        findArchitect: 'Find an architect',
        estimateCost: 'Estimate cost',
        login: 'Log in',
        cta: 'Create project brief'
      },
      hero: {
        title: 'One stop shop for architect services',
        subline:
          'Send one brief, get design proposals, and manage your project in a single platform.',
        cta: 'Create project brief',
        yourProject: 'Your project',
        offerPrefix: 'Offer #'
      },
      joinArchitect: {
        question: 'Are you an architect/designer?',
        cta: 'Join here'
      },
      caraKerja: {
        title: 'How rumantra works',
        cta: 'Start a free brief',
        step1Title: 'Describe your project',
        step1Desc: 'A short brief on type, location, area and budget. Free, about 5 minutes.',
        step2Title: 'Receive proposals',
        step2Desc: 'Verified architects send their fee, timeline and portfolio.',
        step3Title: 'Compare and choose',
        step3Desc: 'Review proposals side by side, then pick the architect that fits best.',
        step4Title: 'Manage it in one dashboard',
        step4Desc: 'Track progress, discuss, and approve each stage with your architect.'
      },
      tipeProyek: {
        title: 'Every design need you have, on rumantra',
        viewAll: 'View all',
        hunian: {
          title: 'Residential',
          desc: 'Build a home that is comfortable, functional, and beautiful'
        },
        komersil: {
          title: 'Commercial',
          desc: 'Align your design with your business goals'
        },
        industrial: {
          title: 'Industrial',
          desc: 'Efficient designs and layouts that support your production and operations'
        },
        lainnya: { title: 'Other', desc: 'From places of worship to schools, it is all here' }
      },
      estimasi: {
        title: 'Find your ideal budget',
        continueCta: 'Continue to project brief',
        jenisLabel: 'Type of work',
        workBaru: 'New build',
        workRenovasi: 'Renovation',
        budgetLabelBaru: 'Estimated construction budget',
        budgetLabelRenovasi: 'Estimated renovation budget',
        budgetHint:
          'Construction cost estimate only, excluding land price. Fill in the second field if you have a range.',
        sampai: 'to',
        minPlaceholder: 'Rp',
        maxPlaceholder: 'Rp (optional)',
        otherNeeds: 'Have other needs, like interior design or a building extension?',
        otherNeedsCta: 'Tell us in your project brief',
        feeEyebrow: 'Estimated design fee',
        feeSubtitle1: 'For architectural design through to working drawings.',
        feeSubtitle2: 'Excludes construction costs.',
        calcToggle: 'Calculation assumptions',
        estimateNote: 'Initial estimate. The final offer follows your project needs and scope.',
        fillBudgetNotice: 'Fill in your estimated budget to see the estimate.',
        invalidRangeNotice: 'The second number should be larger than the first.',
        calcBudgetLabel: 'Construction budget',
        calcScopeLabel: 'Service scope',
        calcScopeValue: 'Architectural design through to working drawings',
        calcCategoryLabel: 'Building category',
        renovationAdjustment: 'renovation adjustment',
        calcMethodLabel: 'Method',
        calcMethodValue: 'IAI Guideline 2007 edition fee table'
      },
      mitra: {
        title: 'The best architects and designers, on rumantra',
        subtitle: 'Our partners have passed a screening process — only the best are here',
        awardTitle: 'Award-winning Architects',
        awardDesc: 'Work recognised at national and international architecture awards.',
        firmTitle: 'Well-established Firms',
        firmDesc: 'Established practices with a long track record and a proven project portfolio.',
        risingTitle: 'Rising Designers',
        risingDesc: 'New talent with fresh ideas and a bold approach to design.'
      },
      ruangProyek: {
        title: 'One place to manage your project.',
        projectName: '12-Room Premium Boarding House',
        projectOwner: 'Aryadiza Gunawan',
        tabDiskusi: 'Discussion',
        tabKontrak: 'Contract',
        tabFile: 'Design files',
        stageLabel: 'Work stages',
        stage1: 'Design concept',
        stage2: 'Design development',
        stage3: 'Working drawings',
        stage4: 'Final handover',
        reviewLabel: 'Waiting for your review',
        item1Title: 'Floor plan 1',
        item1Meta: 'Sent 2 days ago · revision 1 of 3',
        viewBtn: 'View drawing',
        reviseBtn: 'Request revision',
        item2Title: 'Front elevation',
        item2Meta: 'Approved 5 days ago',
        benefit1Title: 'Know exactly where things stand',
        benefit1Desc: 'See work stages, deliverables, and designs awaiting your review.',
        benefit2Title: 'Give clear revision feedback',
        benefit2Desc:
          'Review the design and request revisions in the same project space. Continue the discussion via chat or call.',
        benefit3Title: 'Contracts and files always findable',
        benefit3Desc:
          'Create a contract with your architect and keep design files in one place you can revisit anytime.'
      },
      pembayaran: {
        title: 'Payment follows the progress you approve',
        step1Title: 'Brief and contract agreed',
        step1Desc:
          'Scope of work, revision count, and deadlines are written into the contract before the first payment.',
        step2Title: 'Funds held before disbursement',
        step2Desc:
          'Your payment is held first, not immediately passed on in full to the architect.',
        step3Title: 'Payment released per stage',
        step3Desc:
          'You review the results in the project space, request revisions if needed, then approve that stage.',
        step4Title: 'Help when disputes arise',
        step4Desc:
          'The rumantra team helps mediate using the contract and work history in the project space.'
      },
      faq: {
        title: 'FAQ',
        items: [
          {
            q: 'What is free on rumantra?',
            a: 'Creating a project brief, receiving offers, and comparing architects are free. What you pay for is the architect design fee, as agreed in the contract.'
          },
          {
            q: 'Am I required to choose an incoming offer?',
            a: 'No. You can revise and re-broadcast your project brief, or close it at no cost, if no offer fits yet.'
          },
          {
            q: 'What is the difference between design fee and construction cost?',
            a: 'The design fee is the architect’s service: concept, working drawings, and revisions per the contract. Construction cost covers construction, materials, and permits, and is not included in this page’s estimate.'
          },
          {
            q: 'How long until the first offer arrives?',
            a: 'rumantra is still in beta, so we don’t yet have a reliable average figure. You’ll be notified whenever a new offer arrives in your project space.'
          },
          {
            q: 'Who owns the rights to the design drawings?',
            a: 'Usage rights for the drawings are set out in the contract you agree with the architect before work begins, and can be reviewed anytime in the project space.'
          },
          {
            q: 'What if the result doesn’t match the brief?',
            a: 'Request a revision referencing the brief points that weren’t met, within your contract’s revision allowance.'
          },
          {
            q: 'What if the work is late?',
            a: 'Each stage’s deadline is recorded in the project space and can be escalated to the rumantra team.'
          },
          {
            q: 'What if I disagree with the architect?',
            a: 'Disputes are mediated using the contract, discussion history, and delivered work as reference.'
          },
          {
            q: 'What if the project is cancelled?',
            a: 'Handling of undisbursed funds follows the cancellation terms in your contract.'
          }
        ]
      },
      penutup: {
        title: 'Start with your plan',
        desc1:
          'Tell us your needs, location, and estimated building area to help architects prepare a fitting offer.',
        desc2:
          'After choosing an architect, manage the contract, progress, revisions, and design results together in your project space.',
        cta: 'Create project brief',
        freeNote:
          'Free to create a brief and receive offers. The design fee is agreed with the architect before work begins.',
        architectCta: 'Are you an architect? Join as a rumantra partner'
      }
    }
  },
  mulaiProyek: {
    title: 'Find your dream design',
    subline:
      'Browse designs rumantra can build, or fill a short form if you already know what you want.',
    toggleToForm: 'Fill manual form',
    toggleToBrowse: 'Back to browse designs',
    form: {
      heading: 'Describe your project',
      projectType: 'Category',
      projectScope: 'Project Scope',
      location: 'Location',
      locationPlaceholder: 'e.g. South Jakarta',
      lotSize: 'Lot Size (m²)',
      lotSizePlaceholder: 'e.g. 200',
      budget: 'Design Budget (Architect Fee)',
      budgetPlaceholder: 'e.g. 150.000.000',
      budgetHint:
        'IAI guideline: set a fair design fee reflecting your project’s scope and complexity.',
      description: 'What do you have in mind?',
      descriptionPlaceholder:
        'Number of rooms, style preference, timeline constraints — anything helps.',
      title: 'Project Title',
      titlePlaceholder: 'e.g. Modern Family Home in Bandung',
      phone: 'Phone Number',
      phonePlaceholder: 'e.g. +62 812 3456 7890',
      phoneInvalid: 'Please enter a valid phone number (10-16 digits).',
      startDate: 'Expected Start Date',
      startImmediately: 'Immediately',
      startSpecificDate: 'On a specific date',
      submit: 'Continue',
      submitAuthed: 'Continue to full form',
      submitting: 'Saving...',
      submitError: 'Could not save your brief. Please try again.',
      microcopy: 'No account needed yet — you can sign up right before posting.'
    }
  },
  navbar: {
    switchRole: 'Switch Role',
    architectMode: 'Architect Mode',
    clientMode: 'Client Mode',
    activateArchitect: 'Activate as Architect',
    activateClient: 'Activate as Client',
    profile: 'My Profile',
    portfolios: 'My Portfolios',
    language: 'Language',
    logout: 'Logout'
  },
  hero: {
    title1: 'Get the best',
    title2: 'Architectural design',
    title3: 'Through Comparison!',
    subtitle:
      'Empowering homeowners with data-driven architect selection. Compare designs, budgets, and track your project with precision.',
    cta: 'Get Started'
  },
  solutions: {
    personalArch: 'Personal Architecture',
    projectBrief: 'Project Brief',
    findArchitect: 'Find Architect',
    budgetTool: 'Budget Tool',
    priceAnalysis: 'Price Analysis',
    digitalBlueprint: 'Digital Blueprint',
    trackMilestones: 'Track Milestones',
    aiInspiration: 'AI Inspiration'
  },
  visualization: {
    title: 'Designed by Experts, Built by You.',
    trustedBy: 'Trusted By'
  },
  premium: {
    label: 'rumantra Premium',
    title: 'Professional Solutions for Every Blueprint',
    cta: 'Our Complete Solution',
    features: {
      transparent: {
        title: 'Transparent Costs & Schedule',
        desc: "Every cost is outlined upfront. No hidden fees, no sudden extensions. You know exactly what you're paying for."
      },
      ai: {
        title: 'AI-Based Architecture Brief',
        desc: "Our AI assistant helps you formulate your vision into a professional brief that's easy for architects to execute."
      },
      analysis: {
        title: 'Pragmatic Price Analysis',
        desc: 'Compare offers using our data-driven analysis to ensure you get the best value for your investment.'
      },
      billing: {
        title: 'Pro-rata Billing System',
        desc: 'Funds are only released when milestones are met, ensuring your project stays on track and within budget.'
      }
    }
  },
  gallery: {
    title: 'Limitless Inspiration',
    subtitle: 'Discover the wonders of modern architecture curated from our best professionals.'
  },
  cta: {
    title: 'Ready to Hire Your Expert Architect?',
    subtitle: 'Join thousands of homeowners building their dreams through the rumantra platform.',
    startNow: 'Start Now',
    learnMore: 'Learn More',
    hirePro: 'Hire Pro',
    verified: 'Verified Professionals',
    secure: 'Secure Payment',
    searchNow: 'Search Now'
  },
  footer: {
    description:
      "Indonesia's premium architecture marketplace platform. Connecting your vision with the best professionals.",
    platform: 'Platform',
    company: 'Company',
    legal: 'Legal',
    howItWorks: 'How It Works',
    forArchitects: 'For Architects',
    signUpIn: 'Sign Up / Sign In',
    pricing: 'Pricing',
    about: 'About Us',
    careers: 'Careers',
    blog: 'Blog',
    contact: 'Contact',
    terms: 'Terms & Conditions',
    privacy: 'Privacy Policy',
    rights: 'All rights reserved'
  },
  auth: {
    signup: {
      registerTitle: 'Create a new account',
      registerSubtitle: 'Free. Takes just a minute.',
      registerAs: 'Sign up as',
      roleClient: 'Client',
      roleArchitect: 'Architect',
      orEmail: 'or sign up with email',
      title: 'Join rumantra',
      subtitle: 'Start your architecture journey today',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      agreeTerms: 'I agree to the Terms & Conditions and Privacy Policy',
      legal: {
        prefix: 'I have read and agree to the',
        termsLabel: 'Terms & Conditions',
        and: 'and',
        privacyLabel: 'Privacy Policy',
        suffix: 'of rumantra.',
        loading: 'Loading document...',
        staleTerms: 'Terms were updated, please review and accept again.',
        noticePrefix: 'By continuing, you agree to our',
        noticeSuffix: '.'
      },
      createAccount: 'Create Account',
      alreadyHave: 'Already have an account?',
      signInHere: 'Sign in here',
      orContinueWith: 'Or continue with',
      roleSelection: {
        title: 'I want to',
        subtitle: "Choose how you'll use rumantra",
        client: {
          title: 'Hire an Architect',
          desc: 'Post projects, compare bids, and manage your architectural designs'
        },
        architect: {
          title: 'Offer Services',
          desc: 'Showcase portfolio, submit bids, and grow your practice'
        },
        continue: 'Continue as'
      },
      success: {
        title: 'Account Created Successfully!',
        subtitle: 'Welcome to rumantra',
        message:
          'A verification email has been sent to your email. Please check your inbox or spam folder.',
        redirecting: 'Redirecting you...'
      },
      errors: {
        passwordMismatch: 'Passwords do not match',
        weakPassword: 'Password must be at least 8 characters',
        invalidEmail: 'Invalid email address',
        required: 'This field is required',
        agreeTermsRequired: 'You must agree to the terms and conditions'
      }
    },
    login: {
      title: 'Welcome Back',
      subtitle: 'Sign in to your rumantra account',
      email: 'Email',
      password: 'Password',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot password?',
      signIn: 'Sign In',
      noAccount: "Don't have an account?",
      signUpHere: 'Sign up here',
      orContinueWith: 'Or continue with',
      panelTitle: 'One account for all your projects.',
      panelSubtitle: 'Clients and architects sign in through the same door.',
      perks: [
        'Pick up your brief and projects anytime',
        'Compare proposals from verified architects',
        'Manage contracts, progress, and payments in one place'
      ],
      tabLogin: 'Sign in',
      tabRegister: 'Sign up',
      emailPlaceholder: 'e.g. budi@email.com',
      passwordPlaceholder: 'Your password',
      googleCta: 'Continue with Google',
      linkedinCta: 'Continue with LinkedIn',
      orEmail: 'or with email',
      verified: 'Email verified. Please sign in to continue.',
      errors: {
        invalidCredentials: 'Invalid email or password',
        required: 'This field is required'
      }
    },
    verifyEmail: {
      verifying: 'Verifying your email...',
      pleaseWait: 'Please wait a moment',
      success: 'Email Verified!',
      successMessage:
        'Your email has been verified successfully. You can now sign in to your account.',
      continueToLogin: 'Continue to Sign In',
      failed: 'Verification Failed',
      failedMessage: 'The verification link is invalid or has expired.',
      emailLabel: 'Email',
      resend: 'Resend Verification Email',
      resendSuccess: 'Verification email sent! Please check your inbox.',
      backToLogin: 'Back to Sign In'
    },
    callback: {
      processing: 'Signing you in...',
      pleaseWait: 'Please wait while we complete your login',
      success: 'Login Successful!',
      redirecting: 'You have been signed in successfully.',
      takingYou: 'Taking you to your dashboard...',
      error: 'Login Failed',
      genericError: 'Something went wrong during login. Please try again.',
      returnToLogin: 'Return to Login'
    }
  },
  notFound: {
    title: 'Page Not Found',
    message:
      'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.',
    backHome: 'Back to Home',
    goBack: 'Go Back'
  },
  profile: {
    title: 'My Profile',
    editProfile: 'Edit Profile',
    saveProfile: 'Save Profile',
    cancel: 'Cancel',
    done: 'Done',
    autosave: {
      saving: 'Saving...',
      savedToast: 'Changes saved — profile {percent}% complete',
      error: 'Could not save — check your connection'
    },
    viewMode: {
      practiceName: 'Practice Name',
      city: 'City',
      experience: 'Years of Experience',
      philosophy: 'Design Philosophy',
      expertise: 'Areas of Expertise',
      ktpNum: 'KTP Number',
      ktpVerified: 'KTP Verified',
      npwp: 'NPWP',
      npwpVerified: 'NPWP Verified',
      verified: 'Verified',
      notVerified: 'Not Verified',
      category: 'Practice Type',
      address: 'Address',
      education: 'Education'
    },
    form: {
      practiceName: 'Practice Name',
      practiceNamePlaceholder: 'e.g., Studio Archipelago',
      city: 'City',
      cityPlaceholder: 'e.g., Jakarta',
      experience: 'Years of Experience',
      experiencePlaceholder: 'Select experience range',
      philosophy: 'Design Philosophy',
      philosophyPlaceholder: 'Describe your design philosophy...',
      expertise: 'Areas of Expertise',
      expertisePlaceholder: 'Select at least one area',
      enhanceWithAI: 'Enhance with AI',
      ktpNum: 'KTP Number',
      ktpNumPlaceholder: 'Enter 16-digit KTP number',
      npwp: 'NPWP',
      npwpPlaceholder: 'Enter 15-16 digit NPWP',
      fullnameKtp: 'Full Name (as in KTP)',
      fullnameKtpPlaceholder: 'e.g., Budi Santoso',
      phoneNum: 'Phone Number',
      phoneNumPlaceholder: 'e.g., 08123456789',
      category: 'Practice Type',
      categoryFreelance: 'Freelance',
      categoryCompany: 'Company',
      fullAddress: 'Full Address',
      fullAddressPlaceholder: 'Street, building, unit, etc.',
      province: 'Province',
      provincePlaceholder: 'Select province',
      cityDropdownPlaceholder: 'Select city',
      photo: 'Profile Photo',
      education: 'Education',
      educationAdd: 'Add education',
      educationRemove: 'Remove',
      educationLevel: 'Degree Level',
      educationLevelPlaceholder: 'Select degree level',
      educationUniversity: 'University',
      educationUniversityPlaceholder: 'Select university',
      educationFieldOfStudy: 'Field of Study',
      educationFieldOfStudyPlaceholder: 'e.g., Architecture',
      educationGraduationYear: 'Graduation Year',
      educationGraduationYearPlaceholder: 'e.g., 2018'
    },
    validation: {
      nameMinLength: 'Practice name must be at least 2 characters',
      cityMinLength: 'City must be at least 2 characters',
      ktpNumInvalid: 'KTP number must be exactly 16 digits',
      npwpInvalid: 'NPWP must be 15 or 16 digits',
      phoneNumInvalid: 'Phone number must be 8 to 16 digits'
    },
    toast: {
      updateSuccess: 'Profile updated successfully',
      updateError: 'Failed to update profile. Please try again.',
      loadError: 'Failed to load profile. Please try again.',
      photoUpdateSuccess: 'Profile photo updated',
      photoUpdateError: 'Failed to upload photo. Please try again.'
    },
    completion: {
      title: 'Profile Completion',
      cta: 'Complete your profile',
      basicInfo: 'Basic Info',
      businessLocation: 'Business & Location',
      identityDocs: 'Identity Documents',
      portfolio: 'Portfolio'
    }
  },
  settings: {
    changePassword: {
      title: 'Change Password',
      currentPassword: 'Current Password',
      currentPasswordPlaceholder: 'Enter current password',
      newPassword: 'New Password',
      newPasswordPlaceholder: 'Enter new password',
      confirmPassword: 'Confirm New Password',
      confirmPasswordPlaceholder: 'Re-enter new password',
      submit: 'Update Password',
      policyHint:
        'At least 8 characters, with a digit, uppercase, lowercase, and special character',
      mismatchError: 'New password and confirmation do not match',
      success: 'Password changed successfully',
      error: 'Failed to change password. Please try again.'
    }
  },
  portfolio: {
    title: 'My Portfolios',
    addPortfolio: 'Add Portfolio',
    editPortfolio: 'Edit Portfolio',
    deletePortfolio: 'Delete Portfolio',
    emptyState: {
      title: 'No portfolios yet',
      description: 'Create your first portfolio to showcase your work',
      cta: 'Create Portfolio'
    },
    card: {
      photos: 'photos',
      edit: 'Edit',
      delete: 'Delete',
      madeWithRumantra: 'Made with rumantra'
    },
    modal: {
      createTitle: 'Create Portfolio',
      editTitle: 'Edit Portfolio',
      save: 'Save Portfolio',
      cancel: 'Cancel',
      close: 'Close',
      unsavedChanges: 'You have unsaved changes. Are you sure you want to close?',
      saving: 'Saving...'
    },
    form: {
      title: 'Project Title',
      titlePlaceholder: 'e.g., Tropical House Jakarta',
      description: 'Description',
      descriptionPlaceholder: 'Describe the project...',
      projectDate: 'Project Date',
      projectDatePlaceholder: 'Select date',
      location: 'Location',
      locationPlaceholder: 'e.g., Jakarta, Indonesia',
      projectType: 'Building Category (IAI)',
      projectTypePlaceholder:
        'Open a category and pick the one building type this project belongs to.',
      isBuilt: 'This project has been built',
      images: 'Project Images',
      lockedHint: 'Pulled from the original project data and cannot be changed'
    },
    imageManager: {
      uploadZone: 'Click or drag images here',
      maxImages: 'Maximum 8 images',
      maxSize: 'Maximum 10MB per image',
      currentCount: 'images uploaded',
      addMore: 'Add more images',
      deleteImage: 'Delete image',
      uploading: 'Uploading...'
    },
    validation: {
      titleRequired: 'Project title is required',
      projectDateRequired: 'Project date is required',
      projectTypeRequired: 'Project type is required',
      imagesRequired: 'At least one image is required',
      maxImagesReached: 'Maximum 8 images allowed',
      fileTooLarge: 'Image must be less than 10MB',
      invalidFileType: 'Only image files are allowed'
    },
    toast: {
      createSuccess: 'Portfolio created successfully',
      updateSuccess: 'Portfolio updated successfully',
      deleteSuccess: 'Portfolio deleted successfully',
      createError: 'Failed to create portfolio. Please try again.',
      updateError: 'Failed to update portfolio. Please try again.',
      deleteError: 'Failed to delete portfolio. Please try again.',
      imageUploadSuccess: 'Images uploaded successfully',
      imageUploadError: 'Failed to upload images. Please try again.',
      imageDeleteSuccess: 'Image deleted successfully',
      imageDeleteError: 'Failed to delete image. Please try again.'
    },
    deleteConfirm: {
      title: 'Delete Portfolio',
      message: 'Are you sure you want to delete this portfolio? This action cannot be undone.',
      confirm: 'Delete',
      cancel: 'Cancel'
    }
  },
  bid: {
    aboutStudio: 'About your studio',
    aboutStudioPlaceholder:
      "Tell the client about your studio's expertise, experience, and approach...",
    conceptStatement: 'Concept Statement',
    conceptStatementRequired: 'required',
    conceptStatementPlaceholder:
      "Explain your design concept, key features, and how you'll address the client's needs...",
    conceptStatementHelp:
      'Describe your design plan, concept, and approach for this specific project (max 200 words)',
    attachPortfolios: 'Attach Relevant Portfolios',
    attachPortfoliosHelp: 'Select portfolios that demonstrate your relevant experience',
    wordCount: '{count}/200 words',
    wordCountExceeded: 'Concept statement must not exceed 200 words',
    phasesTotalMismatch:
      'Sum of phase amounts must equal the bid amount. Please adjust your phases.'
  },
  bidCreate: {
    title: 'Submit Bid',
    updateTitle: 'Update Bid',
    subtitle: 'Showcase your expertise and win the project',
    updateSubtitle: 'Continue editing your draft bid',
    projectSummary: 'Project Summary',
    project: 'Project',
    location: 'Location',
    designBudget: 'Design Budget',
    buildArea: 'Build Area',
    buildingType: 'Building Type',
    deliverables: 'Deliverables',
    bidAmount: 'Bid Amount (IDR)',
    timeline: 'Proposed Timeline (days)',
    paymentPhases: 'Payment Phases',
    paymentPhasesHelp: 'Define payment phases. All phases must total your bid amount.',
    submitBtn: 'Submit Bid',
    cancelBtn: 'Cancel',
    submitting: 'Submitting...',
    backToOpportunities: 'Back to Opportunities',
    identityIncompleteTitle: 'Identity verification required to submit',
    identityIncompleteDesc:
      'Complete your KTP, NPWP, full name (as in KTP), and phone number before submitting a bid. You can still save a draft.',
    identityIncompleteAction: 'Complete Profile',
    identityIncompleteError:
      'Please complete your identity information (KTP, NPWP, full legal name, and phone number) in your Profile before submitting a bid. Your draft has been saved.',
    identityIncompleteMissingLabel: 'Missing:',
    identityIncompleteDismiss: 'Later',
    savingDraft: 'Saving draft...',
    completeProfileLink: 'Complete your profile →',
    studioPhilosophyHelp:
      "Prefilled from your profile's Design Philosophy — feel free to tailor it for this project.",
    aspectRatioHint: 'Recommended aspect ratio: 16:9 for the best display in bid comparisons',
    referenceImages: 'Client Reference Images',
    facadeDescriptionPlaceholder:
      'Add context about these facade images (materials, style, site conditions)...',
    interiorDescriptionPlaceholder: 'Add context about these interior images...',
    massingDescriptionPlaceholder: 'Add context about these massing images...',
    zoningDescriptionPlaceholder: 'Add context about these zoning images...',
    deliverableCategories: {
      preliminaryPlanning: 'Preliminary Planning',
      architecturalDesign: 'Architectural Design',
      technicalDesign: 'Technical Design',
      interiorLandscape: 'Interior & Landscape',
      calculationEstimation: 'Calculations & Estimates',
      other: 'Other'
    },
    deliverableItems: {
      SITE_ANALYSIS: 'Site Analysis',
      ZONING_STUDY: 'Zoning & Regulatory Analysis',
      SITE_BLOCK_PLAN: 'Site Plan & Block Plan',
      FLOOR_PLAN: 'Floor Plans',
      ELEVATION_SECTION: 'Elevations & Sections',
      DETAIL_DRAWINGS:
        'Plans & Details (Roof, Ceiling, Floor, Bathroom, Frames, Doors & Windows, etc.)',
      RENDER_3D_EXTERIOR: '3D Exterior Renders',
      RENDER_3D_INTERIOR: '3D Interior Renders',
      RENDER_3D_VIDEO: '3D Walkthrough / Animation Video',
      MATERIAL_FINISHING_SPEC: 'Material & Finishing Specifications',
      STRUCTURAL_DRAWINGS: 'Structural Drawings',
      MECHANICAL_DRAWINGS: 'Mechanical Drawings',
      ELECTRICAL_DRAWINGS: 'Electrical Drawings',
      PLUMBING_DRAWINGS: 'Plumbing Drawings',
      FIRE_PROTECTION_DRAWINGS: 'Fire Protection Drawings',
      STRUCTURAL_CALCULATION: 'Structural Calculations',
      MEP_CALCULATION: 'Mechanical, Electrical & Plumbing (MEP) Calculations',
      INTERIOR_DESIGN: 'Interior Design',
      LANDSCAPE_DESIGN: 'Landscape Design',
      COST_ESTIMATION: 'Cost Estimates',
      ARCHITECTURAL_DRAWINGS: 'Architectural Drawings',
      DESIGN_VISUALIZATION_3D: '3D Visualization & Design Presentation',
      MEP_DRAWINGS: 'Mechanical, Electrical & Plumbing (MEP) Drawings'
    },
    deliverableDescriptions: {
      SITE_ANALYSIS: [
        'The architect studies your land before designing anything — sun and wind direction, access routes and existing trees. This way your building is designed around the real conditions of the site.'
      ],
      ZONING_STUDY: [
        'A check against local government spatial planning rules: whether your land may be built on, the maximum number of floors allowed, and technical limits such as the minimum setback from the road, maximum built-up area, maximum total floor area and minimum green area on your plot. This protects you from a rejected permit or a building that has to be demolished later.'
      ],
      SITE_BLOCK_PLAN: [
        'A Site Plan shows where your building sits within the plot, e.g. the carport, garden and fence.',
        'A Block Plan shows where your plot sits within a wider area, usually used for townhouse projects.'
      ],
      FLOOR_PLAN: [
        'Drawings of the layout and dimensions of every room in the building, seen from above.'
      ],
      ELEVATION_SECTION: [
        'Elevations show the building from all four sides, together with its materials.',
        'Sections show the building "sliced" vertically to reveal details such as ceiling height, floor thickness and roof pitch.'
      ],
      DETAIL_DRAWINGS: [
        "Detailed drawings of the dimensions of your building's components. Useful during construction and as a reference when you buy or design components such as doors, windows and frames."
      ],
      RENDER_3D_EXTERIOR: [
        'Realistic images of how the outside of the building will look, before it is actually built.'
      ],
      RENDER_3D_INTERIOR: [
        'Visualisations of the interior atmosphere, such as lighting, room size, colours and furniture arrangement.'
      ],
      RENDER_3D_VIDEO: ['A video simulation that walks you through the building design.'],
      MATERIAL_FINISHING_SPEC: [
        'A detailed list of the type, brand and quality of materials used in every part of the building. It usually serves as the written reference for checking that installed materials match the agreed quality.'
      ],
      STRUCTURAL_DRAWINGS: [
        'Technical drawings of components such as foundations, columns and beams, with their sizes and strength. This is essential before your design can move into construction.'
      ],
      MECHANICAL_DRAWINGS: [
        'Technical drawings for the air handling system, such as air conditioning and ventilation, throughout the building.'
      ],
      ELECTRICAL_DRAWINGS: [
        'Technical drawings for the electrical routing, including light points, switches and sockets in every room.'
      ],
      PLUMBING_DRAWINGS: ['Technical drawings for clean water, wastewater and rainwater piping.'],
      FIRE_PROTECTION_DRAWINGS: [
        'Technical drawings for fire detection and suppression systems, such as sprinklers and alarms. Usually required for commercial or multi-storey buildings.'
      ],
      STRUCTURAL_CALCULATION: [
        "Technical calculations proving the building's structural strength meets safety standards. Required for the building permit (PBG), and your assurance that the structure is designed on proper calculations rather than guesswork."
      ],
      MEP_CALCULATION: [
        "Calculations of electrical load, water pump capacity and other supporting systems for the building's needs."
      ],
      INTERIOR_DESIGN: [
        'Further design work after the floor plan, choosing colours, furniture and lighting inside each room. It gives your home character and comfort, rather than just finished empty space.'
      ],
      LANDSCAPE_DESIGN: [
        'Detailed design of open areas such as gardens and walkways, covering the number, type and size of elements like trees, stones and lighting.'
      ],
      COST_ESTIMATION: ['An estimate of the total cost needed to build your design.']
    },
    selectAll: 'Select All',
    deselectAll: 'Deselect All'
  },
  identityDocs: {
    title: 'Identity Verification',
    subtitle: 'Required before submitting bids. You can skip this for now.',
    notice:
      'KTP, NPWP, and your full name will be verified manually by the rumantra team. Phone number requires WhatsApp OTP verification, which can be done from your Profile page.',
    fullnameKtp: 'Full Name (as in KTP)',
    fullnameKtpPlaceholder: 'e.g., Budi Santoso',
    ktpNum: 'KTP Number',
    ktpNumPlaceholder: '16-digit KTP number',
    ktpNumError: 'KTP number must be exactly 16 digits',
    npwp: 'NPWP',
    npwpPlaceholder: '15–16 digit NPWP number',
    npwpError: 'NPWP must be 15 or 16 digits',
    phoneNum: 'Mobile Phone Number',
    phoneNumPlaceholder: 'e.g., 08123456789',
    phoneNumHint: 'OTP verification via WhatsApp is done from your Profile page.',
    back: 'Back',
    skip: 'Skip for now',
    save: 'Save & Continue',
    saving: 'Saving...',
    sendOtp: 'Send OTP via WhatsApp',
    otpSent: 'OTP sent to your WhatsApp',
    otpCode: 'Enter OTP Code',
    otpCodePlaceholder: '6-digit OTP',
    verify: 'Verify',
    verifying: 'Verifying...',
    verified: 'Verified',
    notVerified: 'Not verified',
    verifyPhone: 'Verify Phone',
    otpError: 'Invalid or expired OTP. Please try again.',
    resendOtp: 'Resend OTP',
    phoneVerifiedSuccess: 'Phone number successfully verified.'
  },
  clientDashboard: {
    title: 'Client Dashboard',
    subtitle: 'Welcome to your workspace',
    myProjects: 'My Projects',
    seeAll: 'View all',
    noSubmittedProjects: 'No submitted projects yet. Briefs you send will appear here.',
    myProjectsSubtitle: 'Manage and track your architecture projects',
    newProject: 'New Project',
    noProjectsYet: 'No projects yet',
    noProjectsMessage: 'Create your first project to get started with finding architects',
    createProject: 'Create Project',
    bidSingular: 'Bid',
    bidPlural: 'Bids',
    backToProjects: 'Back to Projects',
    receivedBids: 'Received Bids',
    noBidsYet: 'No bids yet',
    noBidsMessage: 'Architects will submit their bids soon',
    acceptBid: 'Accept Bid',
    acceptConfirm: 'Are you sure you want to accept this bid?',
    lotSize: 'Lot Size',
    designBudget: 'Design Budget',
    description: 'Description',
    deliverables: 'Required Deliverables',
    proposedCost: 'Proposed Cost',
    duration: 'Duration',
    days: 'days',
    status: 'Status',
    winner: 'Winner',
    biddingDeadline: 'Bidding Deadline',
    deadline: 'Deadline',
    bidAcceptedTitle: 'Bid Accepted — Finalizing Terms',
    bidAcceptedDesc: 'Review the winning bid terms and confirm before work begins.',
    continueToFinalization: 'Continue to Finalization',
    projectRejectedTitle: 'Project Rejected',
    projectRejectedFallback:
      'This project was rejected. Please contact support for more information.',
    draftBannerTitle: 'This project is still a draft',
    draftBannerDesc: 'Finish filling it in and submit it for review before architects can bid.',
    continueEditing: 'Continue Editing',
    comparativeAnalysis: 'Comparative Analysis',
    subjectA: 'Subject A',
    subjectB: 'Subject B',
    emptyCompareSlot: 'Empty — select from registry',
    compareHint: 'Select a bid from the registry below to begin a comparative analysis',
    bidRegistry: 'Bid Registry',
    welcome: 'Welcome',
    manageProjects: 'Manage your architecture projects',
    newProjectBtn: 'NEW PROJECT',
    activeProjects: 'Active Projects',
    totalBids: 'Total Bids',
    budgetUsed: 'Budget Used',
    activeVentures: 'ACTIVE VENTURES',
    viewAll: 'VIEW ALL →',
    recentActivity: 'Recent Activity',
    noActivityYet: 'No recent activity yet',
    curatedSelection: 'Curated Selection',
    findArchitect: 'Find Your Architect',
    browseStudiosDesc: 'Browse our vetted network of architecture studios ready for your project.',
    browseStudios: 'BROWSE STUDIOS →'
  },
  projectCreate: {
    titleNew: 'Post New Project',
    titleDraft: 'Continue Draft Project',
    subtitle: 'Define your requirements to find the perfect architect',
    phoneRequiredBody:
      'Add your phone number so architects and our team can reach you. This will be saved to your profile.',
    phoneLabel: 'Phone Number',
    phoneRequiredError: 'Phone number is required so architects and our team can reach you.',
    phoneInvalidError: 'Please enter a valid phone number.',
    designBudgetRangeError: 'Maximum price must be equal to or greater than the minimum price.',
    part: 'Part',
    partImages: 'Project Images',
    partGeneral: 'About Your Project',
    partDeliverables: 'Deliverables',
    stepOf: 'Step {step} of {total}',
    nextStepHint: 'Next step: deliverables & project images',
    next: 'Continue',
    back: 'Back',
    saveDraftAndExit: 'Save Draft & Exit',
    selectCategoryFirst: 'Select a category first',
    deliverablesHint:
      'Choose the documents and drawings you need from the architect. Hover over the info icon to see what each deliverable covers.',
    partBudget: 'Budgeting',
    partStartDate: 'Expected Start Date',
    partDeadline: 'Bid Deadline',
    projectTitle: 'Project Title',
    projectTitlePlaceholder: 'e.g., Modern Student Housing in Depok',
    addressSearch: 'Project Site Address',
    addressSearchPlaceholder: 'Search an address or place name...',
    addressSearchHint:
      'Start typing and pick your site from the suggestions — this fills the address, city and province, and drops the map pin for you.',
    addressSearchUnavailable: 'Address search is unavailable. Type the full address instead.',
    addressResolved: 'Detected:',
    pinLocation: 'Pin the Site on the Map',
    pinLocationHint:
      'Click the map to drop a pin, then drag it onto the exact site. Architects use this to read the terrain, vegetation and surroundings before pricing their bid.',
    pinLocationNotSet: 'No pin set yet — architects will see the area only.',
    pinLocationClear: 'Clear pin',
    pinLocationUnavailable:
      'Map is unavailable right now. You can still post the project with the address above.',
    lotSize: 'Lot Size (m²)',
    lotSizePlaceholder: 'e.g., 200',
    lotSizeHint: 'Total land area of the plot.',
    buildArea: 'Build Area (m²)',
    buildAreaPlaceholder: 'e.g., 120',
    buildAreaHint: 'Total floor area to be built. Leave blank if the architect should propose it.',
    buildAreaExceedsLotError: 'Build area cannot exceed the lot size on a single-storey building.',
    numberOfFloors: 'Number of Floors',
    numberOfFloorsPlaceholder: 'e.g., 2',
    detailedRequirements: 'Detailed Requirements',
    detailedRequirementsPlaceholder:
      'Describe number of rooms, style preference (e.g., Industrial, Tropical), timeline constraints...',
    designBudgetLabel: 'Design Fee (Architect Fee)',
    designBudgetDescription: 'This is the main reference for architects to bid',
    designBudgetMinLabel: 'Minimum Price',
    designBudgetMaxLabel: 'Maximum Price',
    designBudgetHint:
      '<strong>IAI Guideline:</strong> According to the Indonesian Institute of Architects (IAI), design fees typically scale with project scope and complexity. Set a price range that reflects a fair budget for your project.',
    startDateHint: 'Let architects know when you expect construction to begin.',
    biddingClosesOn: 'Bidding Closes On',
    biddingDeadlineHint:
      'Set the closing date for architect bids. After this date the project closes automatically and any unselected bids are refunded.',
    biddingDaysLeft: 'days of bidding time',
    biddingDayLeft: 'day of bidding time',
    saving: 'Saving...',
    cancel: 'Cancel',
    posting: 'Posting...',
    postProject: 'Post Project',
    budgetPlaceholder: 'e.g., 2.000.000.000',
    dropImages: 'Drop images here or click to upload',
    imagesHint:
      'Upload photos, mood boards, or inspiration images for your project (max 10 images)',
    imageFormats: 'PNG, JPG, GIF up to 5MB each',
    maxLabel: 'max',
    maxFilesLabel: 'files',
    maxFilesReached: 'You can upload at most {max} images here.',
    projectScope: 'Project Scope',
    category: 'Category',
    subCategory: 'Sub-Category',
    selectScope: 'Select project scope',
    selectCategory: 'Select a category',
    selectSubCategory: 'Select a sub-category',
    immediately: 'Immediately',
    immediatelyDesc: 'Project can start as soon as an architect is hired',
    specificDate: 'On a Specific Date',
    specificDateDesc: 'You have a target date in mind',
    targetStartDate: 'Target Start Date'
  },
  clientProfile: {
    title: 'My Profile',
    subtitle: 'Manage your personal information',
    editProfile: 'Edit Profile',
    saveProfile: 'Save Changes',
    cancel: 'Cancel',
    viewMode: {
      title: 'Profile Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      fullName: 'Full Name',
      email: 'Email Address',
      phoneNumber: 'Phone Number',
      ktpNumber: 'KTP Number',
      verified: 'Verified',
      city: 'City',
      companyName: 'Company Name',
      projectStats: 'Project Statistics',
      projectsMatched: 'Projects Matched',
      projectsCompleted: 'Projects Completed'
    },
    form: {
      firstName: 'First Name',
      firstNamePlaceholder: 'Enter your first name',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Enter your last name',
      phoneNumber: 'Phone Number',
      phoneNumberPlaceholder: '+62 812 3456 7890',
      ktpNumber: 'KTP Number',
      ktpNumberPlaceholder: '1234567890123456',
      ktpReadOnly: 'This field cannot be edited after verification',
      nameReadOnly: 'Name cannot be edited after KTP verification',
      locked: 'Locked',
      verified: 'Verified',
      city: 'City',
      cityPlaceholder: 'e.g., Jakarta, Bandung, Surabaya',
      companyName: 'Company Name (Optional)',
      companyNamePlaceholder: 'Your company or organization',
      readOnly: 'This field cannot be edited'
    },
    validation: {
      firstNameRequired: 'First name is required',
      lastNameRequired: 'Last name is required',
      phoneRequired: 'Phone number is required',
      phoneInvalid: 'Please enter a valid phone number',
      ktpInvalid: 'KTP number must be exactly 16 digits',
      cityRequired: 'City is required'
    },
    toast: {
      loadError: 'Failed to load profile',
      updateSuccess: 'Profile updated successfully!',
      updateError: 'Failed to update profile'
    }
  },
  common: {
    saving: 'Saving...',
    notSet: 'Not set',
    backToDashboard: 'Back to Dashboard',
    back: 'Back',
    optional: 'optional',
    dismiss: 'Dismiss',
    moreInfo: 'More information'
  },
  tokenPurchase: {
    modal: {
      title: 'Purchase Bid Tokens',
      currentQuota: 'Your Current Tokens',
      tier: 'Subscription Tier',
      pricePerToken: 'Price per Token',
      quantity: 'Token Quantity',
      total: 'Total Payment',
      confirm: 'Proceed to Payment',
      cancel: 'Cancel',
      redirectInfo: 'You will be redirected to Xendit payment page to complete the transaction',
      quantityRange: 'Select 1-50 tokens'
    },
    error: {
      default: 'Failed to process token purchase',
      fetchPricing: 'Failed to fetch pricing information',
      invalidQuantity: 'Token quantity must be between 1-50',
      purchaseFailed: 'Failed to create payment request'
    }
  },
  contractAgreement: {
    eyebrowSigned: 'Signed agreement',
    eyebrow: 'Before you confirm',
    title: 'Contract Agreement',
    workspaceLede: 'The agreement both parties signed before work began.',
    openButton: 'Read & Accept Contract Agreement',
    viewButton: 'View',
    closeLabel: 'Close',
    cancel: 'Cancel',
    prerequisiteHint: 'You need to read and accept the contract before you can confirm.',
    scrollHint: 'Scroll to the end of the contract to sign it.',
    signatureLabel: 'Type your full name to sign',
    signaturePlaceholder: 'Your full name',
    signatureHint: 'Type your name exactly as it appears on your account: {name}',
    nameMismatch: 'This must match the name on your account: {name}',
    agreeButton: 'I agree & sign',
    agreeing: 'Signing...',
    accepted: 'Contract accepted',
    clientSignature: 'Client',
    architectSignature: 'Architect',
    notSigned: 'Not yet signed',
    loadError: 'Could not load the contract. Please try again.',
    acceptError: 'Could not record your signature. Please try again.'
  },
  finalization: {
    loading: 'Loading finalization...',
    noAcceptedBid: 'No accepted bid found for this project',
    loadError: 'Failed to load negotiation data',
    tryAgain: 'Try again',
    badge: 'Finalization',
    biddingDeadline: 'Bidding Deadline',
    bothConfirmed: 'Both parties have confirmed — project is now In Progress!',
    yourBid: 'Your Bid',
    proposedPrice: 'Proposed Price',
    timeline: 'Duration',
    days: 'days',
    deliverables: 'Deliverables',
    revisionCommitments: 'Revision Commitments',
    siteAnalysis: 'Site Analysis',
    designPhases: 'Design Phases',
    permitsAndDocs: 'Permits & Docs',
    specialized: 'Specialized',
    construction: 'Construction',
    rev: 'rev',
    designConcept: 'Design Concept',
    portfolioRefs: 'Portfolio References',
    discussion: 'Discussion',
    discussionSubtitle: 'Chat with the client about the project terms',
    chatUnavailable: 'Chat not available yet',
    confirmPrompt: 'Review the agreed terms and confirm to proceed with this project.',
    confirmButton: 'Confirm & Start the Project',
    confirming: 'Confirming...',
    confirmed: "You've confirmed",
    awaitingClient: 'Awaiting client confirmation...',
    clientAlsoConfirmed: 'Client has also confirmed.',
    clientConfirmedStatus: 'Client has confirmed their end.',
    awaitingClientStatus: 'Waiting for client to confirm...',
    confirmDialog: 'Confirm the terms and proceed with this project?',
    confirmError: 'Failed to confirm terms',
    confirmModalEyebrow: 'Confirm & Proceed',
    modalCancel: 'Cancel'
  },
  notifications: {
    title: 'Notifications',
    markAllRead: 'Mark all as read',
    viewAll: 'View all notifications',
    loading: 'Loading notifications...',
    loadError: 'Failed to load notifications',
    retry: 'Try again',
    filterAll: 'All',
    filterUnread: 'Unread',
    subtitleUnread: '{n} unread of {total} notifications.',
    subtitleAllRead: 'All notifications have been read.',
    subtitleEmpty: 'Updates on your projects and bids.',
    allReadTitle: 'All caught up',
    allReadMessage: 'New notifications will appear here.',
    loadMore: 'Load more',
    groups: {
      today: 'Today',
      thisWeek: 'This week',
      older: 'Older'
    },
    cta: {
      viewBids: 'View bids',
      continueFinalization: 'Continue finalization',
      openWorkspace: 'Open workspace',
      completeBrief: 'Complete brief',
      openProject: 'Open project'
    },
    emptyTitle: 'No notifications yet',
    emptyMessage: "You'll be notified about project updates and bids here",
    justNow: 'Just now',
    minutesAgo: '{n} minutes ago',
    hoursAgo: '{n} hours ago',
    daysAgo: '{n} days ago',
    messages: {
      NOTIFICATION_PROJECT_VALIDATED: {
        title: 'Project Approved',
        message: 'Your project "{projectName}" has been validated and is now live'
      },
      NOTIFICATION_PROJECT_REJECTED: {
        title: 'Project Review',
        message: 'Your project "{projectName}" needs review: {reason}'
      },
      NOTIFICATION_BID_RECEIVED: {
        title: 'New Bid Received',
        message: '{architectName} submitted a bid of Rp {amount} on "{projectName}"'
      },
      NOTIFICATION_BID_ACCEPTED: {
        title: 'Bid Accepted',
        message: 'Your bid on "{projectName}" has been accepted!'
      },
      NOTIFICATION_BID_REJECTED: {
        title: 'Bid Update',
        message: 'Your bid on "{projectName}" was not selected'
      },
      NOTIFICATION_TOKEN_PURCHASE_SUCCESS: {
        title: 'Purchase Complete',
        message: '{tokenCount} bid tokens have been added to your account'
      },
      NOTIFICATION_SUBSCRIPTION_ACTIVATED: {
        title: 'Subscription Active',
        message: 'Your {tier} subscription is now active with {tokenCount} tokens'
      },
      NOTIFICATION_SUPPORT_REQUESTED: {
        title: 'Support Request',
        message: 'A user has requested IT support'
      }
    }
  },
  support: {
    requestSupport: 'Request IT Support',
    opening: 'Opening...',
    openError: 'Failed to open support chat',
    chatTitle: 'IT Support Chat',
    chatSubtitle: 'Our team will respond shortly',
    close: 'Close',
    dashboard: {
      title: 'IT Support Requests',
      subtitle: 'Incoming support conversations from architects and clients',
      empty: 'No support requests yet.',
      loading: 'Loading...',
      selectPrompt: 'Select a support request to start chatting',
      projectRef: 'Project',
      bidRef: 'Bid'
    }
  },
  myBids: {
    title: 'My Bids',
    subtitle: 'Track your submitted bids',
    empty: {
      title: 'No bids yet',
      message: 'Submit your first bid to get started',
      cta: 'Browse Opportunities'
    }
  },
  opportunityList: {
    title: 'Available Opportunities',
    subtitle: 'Browse open projects and submit your bids',
    tokensAvailable: 'Bid Tokens Remaining',
    tokensUsedThisMonth: 'Used This Month',
    purchaseTokens: 'Purchase Tokens',
    empty: {
      title: 'No open projects',
      message: 'Check back later for new opportunities'
    }
  },
  phasePayments: {
    loading: 'Loading payment schedule...',
    title: 'Payment Schedule',
    subtitle: 'Project Phases',
    tryAgain: 'Try again',
    inProgressBanner: 'Your project is now In Progress. Pay each phase as work is delivered.',
    noPhases: 'No payment phases found for this project.',
    phase: 'Phase',
    processing: 'Processing...',
    payNow: 'Pay Now',
    paid: 'Paid',
    deliverables: 'Deliverables',
    totalValue: 'Total Project Value',
    remaining: 'Remaining',
    statusPending: 'Pending',
    statusPaid: 'Paid',
    statusExpired: 'Expired',
    statusProcessing: 'Processing'
  },
  projectDetailV2: {
    crumbProjects: 'Projects',
    crumbFindProjects: 'Find Projects',
    crumbMyBids: 'My Bids',
    needsClient: 'Your needs',
    needsArchitect: "Client's needs",
    scopeTitle: 'Project scope',
    interiorAreas: 'Interior areas',
    interiorArea: 'Interior',
    documentsTitle: 'Requested documents',
    documentsCount: '{n} documents selected',
    otherDocuments: 'Other',
    refsTitle: 'References and attachments',
    refsHintClient: 'Images and files you attached when filling in the brief.',
    refsHintArchitect:
      'Images and files from the client. Use them as a guide, not a specification.',
    millionShort: 'M',
    thousandShort: 'K',
    feeArchitect: 'Architect fee budget',
    feeArchitectSub: 'Excluding construction',
    feeDesign: 'Design fee budget',
    feeDesignSub: 'Excluding fabrication',
    lotSize: 'Lot size',
    lotSizeSub: "Client's figure",
    projectArea: 'Project area',
    projectAreaSub: 'Building area',
    floors: 'Floors',
    floorsValue: '{n} floors',
    floorsUnknown: 'Not decided yet',
    unitType: 'Unit type',
    unitTypeSub: 'Apartment unit',
    area: 'Area',
    areaSub: "Client's estimate",
    wallLength: 'Wall length',
    wallLengthSub: 'For the built-in piece',
    startDesign: 'Design start',
    startImmediately: 'As soon as possible',
    submitted: 'Submitted',
    briefSubmitted: 'Brief submitted',
    notesTitle: 'Notes from the rumantra team',
    closesIn: 'Bidding closes in',
    closesInValue: '{d} days {h} hrs',
    biddingClosed: 'Bidding has closed',
    pendingTitle: 'Your brief is being validated',
    pendingBody:
      'The rumantra team checks that the brief is complete before opening it to architects. The brief cannot be changed during this check.',
    pendingFootnote:
      "We'll let you know by email and notification as soon as the brief opens for bids.",
    rejectedTitle: 'Your brief needs changes',
    rejectedBody: 'A few things need to be completed before the brief can be opened to architects.',
    rejectedFootnote:
      'This brief cannot be edited from here yet. You can send a new brief with the corrected details.',
    stepSubmitted: 'Brief submitted',
    stepValidating: 'rumantra team validation',
    stepValidatingMeta: 'Usually done within 24 hours',
    stepRejected: 'Needs changes',
    stepResubmit: 'Resubmit',
    stepResubmitMeta: 'Validated again within 24 hours',
    stepOpen: 'Open for bids',
    stepOpenMeta: 'Verified architects send bids',
    stepCompare: 'Compare and choose',
    stepCompareMeta: 'Pick one bid to continue with',
    archOpenTitle: 'Open for bids',
    archOpenBody:
      'Send a bid with a payment-phase schedule. The client compares bids before choosing.',
    archOpenCta: 'Create bid',
    archDraftTitle: 'Your bid is a draft',
    archDraftBody: 'Your bid is saved but has not been sent. Finish it before bidding closes.',
    archDraftCta: 'Continue bid',
    archSentTitle: 'Your bid has been sent',
    archSentBody: "The client is comparing bids. You'll be notified if yours is chosen.",
    archSentCta: 'View bid',
    archFootnote: "The client's contact details are shared once your bid is accepted.",
    bidAmount: 'Bid amount',
    bidDuration: 'Duration',
    bidDays: '{n} days',
    bidSent: 'Sent',
    bidOverview: 'Studio overview',
    bidConcept: 'Design concept',
    bidViewBrief: 'View project brief',
    bidEdit: 'Edit bid',
    bidAcceptedTitle: 'Your bid was accepted',
    bidAcceptedBody: 'The client chose your bid. Confirm the terms on the finalization page.',
    bidAcceptedWorkingBody: 'The project is under way. Continue in the workspace.',
    openWorkspace: 'Open workspace',
    loadError: 'Failed to load details',
    retry: 'Try again'
  },
  projectDetailArchitect: {
    bidNotSelected: 'Bid not selected',
    bidNotSelectedDesc:
      'The client chose another architect for this project. Your bid stays here for your records.',
    bidWithdrawn: 'Bid withdrawn',
    bidWithdrawnDesc: 'You withdrew this bid. The project is shown here for your records.',
    projectClosed: 'Project closed',
    projectClosedDesc: 'This project is no longer active and is not accepting bids.',
    designBudgetRange: 'Design Budget Range',
    lotSize: 'Lot Size',
    buildArea: 'Build Area',
    buildAreaNotSpecified: 'Not specified — propose one',
    floors: 'Floors',
    visualReferences: 'Visual References',
    visualReferencesHint: 'Click any image to view it full size.',
    siteLocation: 'Site & Location',
    fullAddress: 'Full Address',
    viewSatellite: 'Satellite',
    viewRoadmap: 'Map',
    mapUnavailable: 'Map preview is unavailable.',
    mapLoading: 'Loading map...',
    projectDocuments: 'Project Documents',
    scopeOfWork: 'Scope of Work',
    deliverables: 'Deliverables',
    expectedStartDate: 'Expected Start Date',
    immediately: 'Immediately — can start right away',
    designPreferences: 'Design Preferences',
    bidAccepted: 'Bid Accepted',
    bidAcceptedDesc: 'Review the terms and confirm to start the project.',
    finalizeAgreement: 'Finalize Agreement',
    bidSubmitted: 'Bid Submitted',
    bidSubmittedDesc: 'Your bid is pending review by the client.',
    draftSaved: 'Draft Saved',
    draftSavedDesc: 'Continue editing to complete your bid.',
    bidRejected: 'Bid Not Selected',
    bidRejectedDesc: 'Your bid was not selected for this project.',
    noBidYet: 'Create Bid',
    noBidYetDesc: 'Submit a bid to compete for this project.',
    projectClosedBidding: 'Project is Closed',
    projectClosedBiddingDesc: 'Bidding has ended for this project.'
  },
  bidComparison: {
    bidA: 'Bid A',
    bidB: 'Bid B',
    appointed: '✓ Appointed',
    appointLead: 'Appoint Lead Architect',
    appointModalEyebrow: 'Confirm Appointment',
    appointModalTitle: 'Appoint as Lead Architect?',
    appointModalWarningTitle: 'Please Read Before Confirming',
    appointModalWarningItem1: 'The project moves into negotiation with this architect immediately.',
    appointModalWarningItem2: 'Other bids will no longer be available for comparison.',
    appointModalWarningItem3: 'This action cannot be undone from here.',
    appointModalCancel: 'Cancel',
    appointModalConfirm: 'Yes, Appoint Now',
    appointModalLoading: 'Appointing...',
    visualOverlay: 'Visual Overlay',
    sideBySize: 'Design Review Side-by-Side',
    adjustSlider: 'Adjust slider for relative review',
    facade: 'Facade',
    interior: 'Interior',
    massing: 'Massing',
    zoning: 'Zoning',
    noImages: 'No {type} images',
    reviewing: 'Reviewing',
    conceptStatements: 'Design Concepts',
    studioOverview: 'Studio Overview',
    conceptStatement: 'Concept Statement',
    noStudioOverview: 'No studio overview provided.',
    noConceptStatement: 'No concept statement provided.',
    summaryStats: 'Summary Stats',
    metricHeader: 'Metric',
    costEstimate: 'Cost Estimate',
    timeline: 'Timeline',
    portfolios: 'Portfolios',
    noPortfolios: 'No portfolios linked',
    scopeAlignment: 'Scope Alignment',
    paymentScheduleTitle: 'Payment Schedule',
    noPhases: 'No payment phases specified',
    deliverable: 'deliverable',
    deliverables: 'deliverables',
    days: 'days',
    imageOf: '{current} of {total}',
    prevImage: 'Previous image',
    nextImage: 'Next image',
    matchingDeliverable: 'Matches project requirement',
    additionalDeliverable: 'Additional offering from architect',
    missingDeliverable: 'Not covered in this bid',
    uncoveredTitle: 'Not yet covered from project requirements',
    paymentFlowInfo: 'View payment flow details',
    paymentFlowTitle: 'Payment Flow',
    paymentFlowUpfront: '{amount} is due upfront when this phase begins.',
    paymentFlowTimelineWithDeliverables:
      'Assuming no revision requests, the architect is expected to complete and submit {deliverables} within {days} days.',
    paymentFlowTimeline:
      'Assuming no revision requests, this phase is expected to be completed within {days} days.',
    paymentFlowRevisions:
      'This phase includes up to {rounds} round(s) of revisions should adjustments be needed.'
  },
  paymentPhaseBuilder: {
    availableDeliverables: 'Available Deliverables',
    availableDeliverablesHelp:
      'Click a deliverable to assign it to the active phase, or drag it to a phase.',
    paymentPhases: 'Payment Phases',
    addPhase: '+ Add Phase',
    phasesTotal: 'Phases total',
    percentage: 'Percentage (%)',
    revisionRounds: 'Revision rounds',
    estimatedDays: 'Est. days',
    daysTotal: 'Total duration',
    phase: 'Phase',
    dropZoneHint: 'Drop deliverables here or click above to assign',
    selectAll: 'Select all',
    addAllRequired: '+ Add all required'
  },
  bidDetail: {
    imageArchived: 'Image no longer available',
    backToProject: 'Back to Project',
    proposedCost: 'Proposed Cost',
    timeline: 'Timeline',
    days: 'days',
    studioOverview: 'Studio Overview',
    noStudioOverview: 'No studio overview provided.',
    designConcept: 'Design Concept',
    paymentSchedule: 'Payment Schedule',
    portfolioProjects: 'Related Portfolio Projects',
    facade: 'Facade',
    noFacade: 'No facade images available',
    interior: 'Interior',
    noInterior: 'No interior images available',
    massing: 'Massing',
    noMassing: 'No massing images available',
    zoning: 'Zoning',
    noZoning: 'No zoning images available',
    acceptBid: 'Accept This Bid',
    accepted: 'Accepted',
    submittedOn: 'Submitted on {date}',
    matchingDeliverable: 'Matches project requirement',
    additionalDeliverable: 'Additional offering from architect',
    missingDeliverable: 'Not covered in this bid',
    uncoveredTitle: 'Not yet covered from project requirements'
  },
  bidCard: {
    appointed: 'Appointed',
    concept: 'Concept',
    selectedForCompare: 'Selected for Compare',
    addToCompare: 'Add to Compare',
    viewDetails: 'View Full Details'
  },
  portfolioPopup: {
    built: 'Built',
    concept: 'Concept',
    noDescription: 'No description provided.'
  },
  bidTable: {
    studio: 'Studio',
    rating: 'Rating',
    ratingComingSoon: 'Rating coming soon',
    location: 'Location',
    education: 'Education',
    noEducation: '—',
    totalPrice: 'Total Price',
    totalDuration: 'Total Duration',
    detail: 'Detail',
    filterByCity: 'City',
    allCities: 'All Cities',
    priceMin: 'Min Price',
    priceMax: 'Max Price',
    clearFilters: 'Clear filters',
    noPendingBids: 'No pending bids yet',
    noBidsMatchFilters: 'No bids match your filters',
    minPrice: 'Min Price',
    avgPrice: 'Avg Price',
    maxPrice: 'Max Price',
    minDuration: 'Min Duration',
    avgDuration: 'Avg Duration',
    maxDuration: 'Max Duration'
  },
  projectCard: {
    manage: 'Manage →',
    continueDraft: 'Continue Draft →',
    minutesAgo: '{n}m ago',
    hoursAgo: '{n}h ago',
    daysAgo: '{n}d ago',
    monthsAgo: '{n}mo ago'
  },
  clientFinalization: {
    itSupportInvited: 'IT Support invited',
    winningBid: 'Winning Bid',
    paymentSchedule: 'Payment Schedule',
    phase: 'Phase',
    revisionRound: 'revision round',
    revisionRounds: 'revision rounds',
    total: 'Total',
    discussionSubtitle: 'Chat with the architect about the terms',
    clientPanel: {
      confirmed: "You've confirmed",
      architectAlsoConfirmed: 'Architect has also confirmed.',
      awaitingArchitect: 'Awaiting architect confirmation...',
      confirmPrompt: 'Review the bid terms and discuss with the architect before confirming.',
      confirmButton: 'Confirm & Proceed to Payment',
      confirmDialog: 'Confirm the terms and proceed to payment?',
      confirming: 'Confirming...',
      rejectButton: 'Reject Terms & Reopen Bidding'
    },
    architectPanel: {
      confirmed: "You've confirmed",
      clientAlsoConfirmed: 'Client has also confirmed.',
      awaitingClient: 'Awaiting client confirmation...',
      confirmPrompt: 'Review the agreed terms and confirm to proceed with the project.',
      confirmButton: 'Confirm & Proceed to Payment'
    },
    rejectDialog: {
      title: 'Reject Terms & Reopen Bidding?',
      message:
        "This will reject the current bid, refund the architect's token, and reopen the project for new bids. This action cannot be undone.",
      cancel: 'Cancel',
      confirm: 'Yes, Reject & Reopen',
      rejecting: 'Rejecting...',
      successToast: 'Bidding reopened successfully',
      error: 'Failed to reject terms'
    }
  },
  errors: {
    CONTRACT_NOT_AVAILABLE: 'The contract is not ready yet — a bid must be accepted first.',
    CONTRACT_ALREADY_SIGNED: 'You have already signed this contract.',
    CONTRACT_SIGNATURE_MISMATCH: 'The signature must match the name on your account.',
    CONTRACT_STALE: 'The contract was updated. Please reopen it and sign again.',
    CONTRACT_NOT_ACCEPTED: 'Please read and accept the contract agreement first.',
    'firstName.required': 'First name is required',
    'lastName.required': 'Last name is required',
    'name.verified.cannot.modify': 'Cannot modify name after KTP verification',
    'phone.required': 'Phone number is required',
    'phone.invalid.format': 'Invalid phone number format. Must be 10-16 digits.',
    'ktp.required': 'KTP number is required',
    'ktp.invalid.format': 'KTP number must be exactly 16 digits',
    'ktp.verified.cannot.modify': 'Cannot modify KTP number after verification',
    BID_NOT_DRAFT: 'Bid can only be submitted when in draft status.',
    BID_NOT_FOUND: 'Bid not found.',
    BID_IMAGE_NOT_FOUND: 'Bid image not found.',
    UNAUTHORIZED_BID_ACCESS: 'You are not authorized to access this bid.',
    ALREADY_BASIC_TIER: 'You are already subscribed to the Basic tier.',
    UNAUTHORIZED_ARCHITECT_ACCESS: 'You are not authorized to access this architect profile.',
    ARCHITECT_NOT_FOUND: 'Architect not found.',
    PROJECT_NOT_FOUND: 'Project not found.',
    INVALID_PURCHASE_QUANTITY: 'Invalid token purchase quantity.',
    PURCHASE_NOT_FOUND: 'Token purchase not found.',
    UNAUTHORIZED_PURCHASE_ACCESS: 'You are not authorized to access this purchase.',
    XENDIT_PAYMENT_ERROR: 'Payment processing failed. Please try again.',
    UNAUTHORIZED_PROJECT_ACCESS: 'You are not authorized to access this project.',
    PURCHASE_ALREADY_COMPLETED: 'This purchase has already been completed.',
    ATTACHMENT_NOT_FOUND: 'Attachment not found.',
    ATTACHMENT_MODIFY_NOT_DRAFT: 'Attachments can only be modified while the project is in draft.',
    ATTACHMENT_EMPTY_FILE: 'File is empty.',
    ATTACHMENT_INVALID_TYPE: 'Invalid file type.',
    ATTACHMENT_SIZE_EXCEEDED: 'File size exceeds the maximum allowed limit.',
    PHASE_NOT_FOUND: 'Payment phase not found.',
    PHASE_ALREADY_PAID: 'This phase has already been paid.',
    STALE_TERMS: 'Terms were updated, please review and accept again.',
    MISSING_REQUIRED_ACCEPTANCE: 'Please agree to the Terms & Conditions and Privacy Policy.'
  },
  clientNav: {
    dashboard: 'Dashboard',
    projects: 'Projects',
    messages: 'Messages',
    payments: 'Payments'
  },
  clientPaymentsPage: {
    title: 'Payments',
    subtitle: 'Active Projects',
    selectProject: 'Select a project to view and manage phase payments.',
    noProjects: 'No active projects with payments',
    noProjectsHint: 'Projects move here once both parties have confirmed the deal.',
    viewProjects: 'View my projects →',
    phase: 'Phase',
    of: 'of',
    pending: 'pending',
    allPaid: 'All paid'
  },
  activeProjectDashboard: {
    paidRefresh: "I've Paid — Refresh",
    processing: 'Processing...',
    payNow: 'Pay Now',
    payNowAgain: 'Pay Now Again',
    deliverables: 'Deliverables',
    loading: 'Loading project...',
    tryAgain: 'Try again',
    projectDashboard: 'Project Dashboard',
    inProgress: 'In Progress',
    phase: 'Phase',
    of: 'of',
    openWorkspace: 'Open Workspace',
    budget: 'Budget',
    totalValue: 'Total Value',
    paid: 'Paid',
    remaining: 'Remaining',
    architect: 'Architect',
    scopeOfWork: 'Scope of Work',
    noPhases: 'No payment phases found for this project.',
    expired: 'Expired',
    pending: 'Pending',
    payFirst: 'first',
    phases: 'phases',
    percentComplete: '% complete'
  },
  projectWorkspace: {
    payNow: 'Pay Now',
    getLink: 'Get Payment Link',
    payoutProcessing: 'Payout Processing',
    payoutProcessingHint: 'Transfer is being verified by Xendit. Please wait for confirmation.',
    payoutFailed: 'Payout Failed',
    payoutFailedHint: 'Transfer failed to process. Please retry with correct account details.',
    retryPayout: 'Retry Payout',
    requestPayout: 'Request Payout',
    deadline: 'Deadline',
    remaining: 'remaining',
    initialDelivery: 'Initial Delivery',
    revisionRound: 'Revision',
    revisionEachRequired: 'Add a comment for every deliverable you marked.',
    revisionPooledHint: 'All {n} will be sent back together and cost a single revision round.',
    revisionRoundLabel: 'Revision {n}',
    deliverableRevisionRequested: 'Revision requested',
    reviseCta: 'Revise',
    reviseUndoCta: 'Undo',
    reviseFromTableHint: 'Need changes? Mark the deliverables below with Revise.',
    revisionBasketTitle: 'Deliverables to revise',
    revisionBasketHint: 'Tell the architect what needs to change on each one.',
    revisionCommentLabel: 'Comment',
    revisionSubmitCta: 'Send revision request',
    revisionConfirmTitle: 'This uses one revision round',
    revisionConfirmWarning:
      'Sending this consumes 1 of {max} revisions for this phase. {left} will remain.',
    revisionConfirmSubmit: 'Yes, request revision',
    revisionModalTitle: 'Revision Notes',
    revisionModalHint: 'Describe what changes you need the architect to make.',
    revisionModalPlaceholder: 'e.g., Please adjust the floor plan to include...',
    revisionModalSubmit: 'Request Revision',
    revisionModalCancel: 'Cancel',
    revisionModalRequired: 'Please describe what changes are needed.',
    completed: 'Project Completed',
    active: 'Active Project',
    archiving: 'Archiving...',
    archiveToPortfolio: 'Archive to Portfolio',
    viewInPortfolio: 'View in Portfolio',
    archiveError: 'Failed to archive project to portfolio',
    loading: 'Loading workspace...',
    tryAgain: 'Try again',
    loadError: 'Failed to load workspace',
    eyebrow: 'Project Workspace',
    titleFallback: 'Active Project',
    of: 'of',
    phasesDone: 'phases done',
    completedBadge: 'Completed',
    inProgressBadge: 'In Progress',
    viewDetail: 'View Details ↗',
    totalValue: 'Total Value',
    paidLabel: 'paid',
    paymentPhasesTitle: 'Payment Phases',
    noPhasesTitle: 'No phases yet',
    noPhasesDesc: 'Phase details will appear once the architect sets them up.',
    initializing: 'Initializing...',
    initPhasesBtn: 'Initialize Phases from Bid',
    phaseFallback: 'Phase {n}',
    descriptionLabel: 'Description',
    revisionsLeftLabel: 'Revisions Left',
    revisionsExhausted: 'Revisions exhausted',
    actionsLabel: 'Actions',
    notStartedTitle: 'Not Started',
    notStartedDesc: 'This phase will activate once the previous phase is fully complete.',
    paymentRequiredTitle: 'Payment Required',
    paymentRequiredDesc:
      'Create an invoice to start this phase. The architect can begin work once payment is confirmed.',
    creating: 'Creating...',
    createInvoice: 'Create Invoice',
    invoiceSentTitle: 'Invoice Sent',
    invoiceSentDesc: 'Awaiting payment confirmation.',
    workInProgressTitle: 'Work In Progress',
    workInProgressDesc:
      'The architect is working on this phase. Deliverables will appear below once submitted.',
    workSubmittedTitle: 'Work Submitted',
    workSubmittedDesc:
      'Review the deliverables below, then approve, request a revision, or file a dispute.',
    approveBtn: 'Approve',
    requestRevisionBtn: 'Request Revision',
    disputeBtn: 'Dispute',
    disputeLinkBtn: 'Or file a dispute',
    disputeModalTitle: 'File a dispute',
    disputeModalDesc: 'Our support team reviews the phase and contacts both parties.',
    disputeReasonLabel: 'Dispute Reason',
    disputeReasonPlaceholder: "Describe what doesn't match the agreed specification...",
    submitting: 'Submitting...',
    submitDispute: 'Submit Dispute',
    cancel: 'Cancel',
    workApprovedTitle: 'Work Approved',
    workApprovedDesc: 'You approved this phase. The architect is processing their payout.',
    underDisputeTitle: 'Under Dispute',
    underDisputeDesc:
      'This phase is being reviewed by our support team. Both parties will be contacted.',
    phaseCompleteDisbursed: 'Phase complete. Payout disbursed to the architect.',
    deliverablesLabel: 'Deliverables',
    fileCountSuffix: 'files',
    noDeliverablesUploaded: 'No deliverables uploaded yet',
    activityLogLabel: 'Activity Log',
    loadingActivity: 'Loading activity...',
    noActivityRecorded: 'No activity recorded yet',
    logActions: {
      PHASE_CREATED: 'Phase created',
      PHASE_BILLED: 'Invoice created',
      PAYMENT_RECEIVED: 'Payment received',
      DELIVERABLE_UPLOADED: 'File uploaded by architect',
      PHASE_SUBMITTED_FOR_REVIEW: 'Phase submitted for review',
      DELIVERABLE_APPROVED: 'Deliverable approved',
      REVISION_REQUESTED: 'Revision requested',
      DELIVERABLE_DISPUTED: 'Dispute filed',
      PAYOUT_INITIATED: 'Payout requested by architect',
      PAYOUT_COMPLETED: 'Payout completed',
      PAYOUT_FAILED: 'Payout failed'
    },
    chatTitle: 'Project Chat',
    activeOnProject: 'Active on project',
    chatUnavailableHint: 'Chat becomes available once both parties confirm the project.',
    projectDetailsLabel: 'Project Details',
    projectInfoLabel: 'Project Information',
    locationLabel: 'Location',
    categoryLabel: 'Category',
    buildingFunctionLabel: 'Building Function',
    lotSizeLabel: 'Lot Size',
    floorsLabel: 'Floors',
    designBudgetLabel: 'Design Budget',
    scopeOfWorkLabel: 'Scope of Work',
    projectDeliverablesLabel: 'Project Deliverables',
    winningBidLabel: 'Winning Bid',
    bidAmountLabel: 'Bid Amount',
    workDaysSuffix: 'days of work',
    phasePlanLabel: 'Phase Plan',
    days: 'days',
    revisionsWord: 'revisions',
    closeLabel: 'Close',
    confirmApprovalEyebrow: 'Confirm Approval',
    approveModalTitle: "Approve This Phase's Work?",
    approveModalWarningTitle: '⚠️ Please Read Before Approving',
    approveModalItem1:
      'By approving, you confirm the work <strong>meets</strong> the agreed specifications.',
    approveModalItem2:
      'The architect will be able to request a <strong>payout</strong> for this phase immediately after approval.',
    approveModalItem3: 'If issues arise after approval, please contact our support team.',
    approveModalConfirmLabel: 'By approving:',
    approveModalConfirmDesc:
      'You confirm the delivered work meets the agreed specifications. The architect will be able to initiate their payout immediately. This action cannot be undone.',
    approving: 'Approving...',
    confirmApproveBtn: 'Yes, Approve Now',
    downloadLabel: 'Download',
    previewUnavailable: 'Preview is not available for this file type',
    downloadFileLabel: 'Download File',
    statusLabels: {
      NOT_STARTED: 'Not Started',
      PENDING: 'Payment Pending',
      BILLED: 'Invoice Sent',
      PAID: 'Paid',
      IN_PROGRESS: 'In Progress',
      DELIVERED: 'Delivered',
      APPROVED: 'Approved',
      DISBURSED: 'Completed',
      DISPUTED: 'Disputed'
    },
    architectFallback: 'Architect',
    billError: 'Failed to create invoice',
    approveError: 'Failed to approve phase',
    revisionError: 'Failed to request revision',
    disputeError: 'Failed to submit dispute',
    initError: 'Failed to initialize phases',
    overdueDays: '{d} days overdue',
    dueToday: 'Due today!',
    oneDayLeft: '1 day left',
    daysLeftCount: '{d} days left',
    noDueDate: 'No deadline set yet',
    currentPhaseLabel: 'Current phase',
    progressByPhaseTitle: 'Progress by phase',
    timelineFinishLine: 'Target finish {target} · Forecast {forecast}',
    timelineFinishedLine: 'Target finish {target} · Finished {forecast}',
    timelineTargetLane: 'TARGET',
    timelineActualLane: 'ACTUAL',
    timelineToday: 'Today',
    timelineFinishShort: '{date} · finish',
    timelineOpenAll: 'Phases & Deliverables',
    timelineOpenPhase: 'Click to open Phase {n} deliverables',
    timelineOpenAria: 'Open {phase} · {title} in Phases & Deliverables',
    legendTarget: 'Target from bid',
    legendCompleted: 'Completed',
    legendInProgress: 'In progress',
    legendForecast: 'Forecast',
    ackOnTrackClient: 'Your architect is working to the bid timeline',
    ackOnTrackArchitect: 'You are working to the bid timeline',
    ackOnTrackSub: 'Speed vs bid appears once the first phase is submitted.',
    ackFasterClient: 'Your architect delivered {days} faster than the bid',
    ackFasterArchitect: 'You delivered {days} faster than the bid',
    ackSlowerClient: 'Your architect delivered {days} slower than the bid',
    ackSlowerArchitect: 'You delivered {days} slower than the bid',
    ackOnTimeClient: 'Your architect is right on the bid timeline',
    ackOnTimeArchitect: 'You are right on the bid timeline',
    ackAcrossOne: 'Across {n} submitted phase, measured from start to submission.',
    ackAcrossMany: 'Across {n} submitted phases, measured from start to submission.',
    dayCountOne: '{n} day',
    dayCountMany: '{n} days',
    chipFaster: '{d}d faster',
    chipSlower: '{d}d slower',
    chipOnSchedule: 'On schedule',
    chipDayOf: 'Day {n} of {total}',
    backToTimeline: 'Back to timeline',
    targetFromBidLabel: 'Target · from bid',
    actualLabel: 'Actual',
    targetRangeLong: '{range} · {d} days',
    actualRange: '{range}',
    actualDoneLong: '{range} · submitted in {d} days',
    actualAwaitingLong: 'Since {date} · submitted in {d} days, awaiting approval',
    actualActiveLong: 'Since {date} · forecast {end}',
    actualForecastLong: 'Forecast {range}',
    noPhasesYet: 'No phases yet',
    openDeliverablesLink: 'Open deliverables',
    approveEachDesc:
      'Review each deliverable below and approve it. The phase completes on its own once every one is approved.',
    dueOnLabel: 'due {date}',
    autoDeliverDesc:
      'This phase is sent to the client for review automatically, as soon as every deliverable has been uploaded.',
    clientCountdownDesc:
      'The architect has until this deadline to upload every deliverable. It goes to your review automatically once they do.',
    totalProjectValue: 'Total Project Value',
    disbursedLabel: 'disbursed',
    percentCompleteSuffix: 'complete',
    phasesWord: 'phases',
    noPhasesDescArchitect: 'Phase details will appear once the client sets them up.',
    awaitingClientPaymentTitle: 'Awaiting Client Payment',
    awaitingClientPaymentDesc:
      'The client needs to create an invoice and pay for this phase before you can start work.',
    invoiceSentDescArchitect:
      'The invoice has been sent to the client. You will be notified once payment is confirmed.',
    workPhaseActiveTitle: 'Work Phase Active',
    workPhaseActiveDesc:
      'Payment confirmed. Upload your deliverables when ready for client review.',
    uploadFileLabel: 'Upload File',
    chooseFileLabel: 'Choose file',
    fileDescPlaceholder: 'File description (optional)',
    uploading: 'Uploading...',
    uploadBtn: 'Upload',
    markCompleteLabel: 'Mark Complete',
    markCompleteDesc:
      'Once all files are uploaded, submit this phase for client review. The client will be notified.',
    submitForReviewBtn: 'Submit for Review',
    underClientReviewTitle: 'Under Client Review',
    underClientReviewDesc:
      'Your deliverables have been submitted. Awaiting approval or a revision request from the client.',
    workApprovedExclaim: 'Work Approved!',
    workApprovedArchitectDesc: 'The client approved your work. Request your payout below.',
    payoutDetailsLabel: 'Payout Details',
    selectBankPlaceholder: 'Select bank...',
    accountNumberLabel: 'Account Number',
    accountNumberPlaceholder: 'e.g. 1234567890',
    accountHolderLabel: 'Account Holder Name',
    accountHolderPlaceholder: 'Name as per bank passbook',
    disbursementAmountLabel: 'Payout amount',
    xenditTransferHint:
      'The transfer will be processed via Xendit. Please double-check the account details.',
    processing: 'Processing...',
    confirmPayoutBtn: 'Confirm Payout',
    payoutDisbursedSuccess: 'Payout disbursed successfully.',
    confirmPayoutEyebrow: 'Confirm Payout',
    confirmPayoutWarning:
      'Double-check the details below before funds are disbursed via Xendit. This action cannot be undone.',
    amountLabel: 'Amount',
    holderNameLabel: 'Holder Name',
    confirmPayoutBtnFull: 'Yes, Disburse Funds Now',
    clientFallback: 'Client',
    uploadError: 'Failed to upload file',
    submitReviewError: 'Failed to submit for review',
    payoutError: 'Failed to request payout',
    statusLabelsArchitect: {
      NOT_STARTED: 'Not Started',
      PENDING: 'Pending',
      BILLED: 'Billed',
      PAID: 'Paid',
      IN_PROGRESS: 'In Progress',
      DELIVERED: 'Delivered',
      APPROVED: 'Approved',
      DISBURSED: 'Disbursed',
      DISPUTED: 'Disputed'
    },
    logActionsArchitect: {
      PHASE_CREATED: 'Phase created',
      PHASE_BILLED: 'Invoice created',
      PAYMENT_RECEIVED: 'Payment received',
      DELIVERABLE_UPLOADED: 'File uploaded',
      PHASE_SUBMITTED_FOR_REVIEW: 'Phase submitted for review',
      DELIVERABLE_APPROVED: 'Deliverable approved by client',
      REVISION_REQUESTED: 'Revision requested by client',
      DELIVERABLE_DISPUTED: 'Dispute filed by client',
      PAYOUT_INITIATED: 'Payout requested',
      PAYOUT_COMPLETED: 'Payout completed',
      PAYOUT_FAILED: 'Payout failed'
    },
    tabSummary: 'Summary',
    tabPhases: 'Phases & Deliverables',
    tabContract: 'Contract & Payment',
    projectChatBtn: 'Project Chat',
    hideChatBtn: 'Hide Chat',
    needsActionLabel: 'Needs your action',
    nothingWaiting: 'Nothing waiting on you right now',
    allPhasesLink: 'All phases',
    reviewCta: 'Review',
    uploadCta: 'Upload',
    colDeliverable: 'Deliverable',
    colStatus: 'Status',
    colAction: 'Action',
    colFiles: 'Files',
    approvedOf: '{approved} of {total} approved',
    awaitingUpload: 'Awaiting upload',
    unlocksWithPhase: 'Unlocks with this phase',
    filesUpdated: '{n} files \u00b7 updated {at}',
    noFilesLabel: 'No files',
    untaggedFilesLabel: 'Other files',
    filesCountLabel: '{n} files',
    deliverableApproved: 'Approved',
    deliverableAwaiting: 'Awaiting approval',
    deliverableMissing: 'Not submitted',
    deliverableLocked: 'Locked',
    filesModalEyebrow: 'Files for deliverable',
    filesTaggedTo: '{n} file(s) tagged to this deliverable \u00b7 {phase}',
    previewBtn: 'Preview',
    contractLede:
      'Funds are held in rumantra escrow and disbursed per phase once you approve the work.',
    colPhase: 'Phase',
    colDeadline: 'Deadline',
    colAmount: 'Amount',
    shareOfContract: '{share}% of contract value',
    percentComplete: '{pct}% complete',
    downloadPdfBtn: 'Download PDF',
    requestAmendmentBtn: 'Request Amendment',
    transactionHistoryLabel: 'Transaction History',
    noTransactions: 'No transactions yet',
    closedLabel: 'Closed',
    showLabel: 'Show',
    hideLabel: 'Hide',
    toastPhaseApproved: 'All deliverables approved \u00b7 phase approved',
    toastItemApproved: 'Approved \u00b7 {name}',
    paidToDateLabel: 'Paid to date',
    disbursedToYouLabel: 'Disbursed to you',
    heldInEscrowLabel: 'Held in escrow',
    notYetFundedLabel: 'Not yet funded',
    createInvoiceInContract: 'Create the invoice in Contract & Payment',
    payInContract: 'Pay in Contract & Payment',
    payoutInContract: 'Request the payout in Contract & Payment',
    deliverablesAwaitingTitle: '{n} deliverable(s) awaiting your decision',
    reviewDeliverablesCta: 'Review deliverables',
    deliverablesUploadedCount: '{done} of {total} deliverables uploaded',
    uploadAtLeastOne: 'Upload at least one deliverable before submitting',
    deliverablesMissingCount: '{n} deliverable(s) not uploaded yet',
    notSubmittedYet: 'Uploaded, but not submitted \u2014 the client cannot review it yet',
    reuploadCta: 'Upload again'
  },
  architectDashboard: {
    welcome: 'Welcome',
    manageProjects: 'Manage your architecture bids',
    findProjects: 'FIND PROJECTS',
    activeBids: 'Active Bids',
    accepted: 'Accepted',
    bidTokens: 'Bid Tokens',
    myBids: 'MY BIDS',
    viewAll: 'VIEW ALL →',
    noBidsYet: 'No bids submitted yet',
    browseProjects: 'Browse Projects',
    tokensRemaining: 'remaining',
    plan: 'Plan:',
    buyTokens: 'BUY TOKENS →',
    opportunities: 'Opportunities',
    findNewProjects: 'Find New Projects',
    browseProjectsDesc: 'Browse open projects from clients looking for architects.',
    browseProjectsBtn: 'BROWSE PROJECTS →'
  },
  superuserDashboard: {
    title: 'Backoffice Dashboard',
    subtitle: 'Platform overview for superuser operations',
    pendingApproval: 'Pending Approval',
    pendingApprovalDesc: 'projects awaiting validation',
    negotiation: 'Negotiation',
    negotiationDesc: 'projects in negotiation',
    activeDisputes: 'Active Disputes',
    activeDisputesDesc: 'phases in DISPUTED status',
    inProgress: 'In Progress',
    inProgressDesc: 'active projects'
  },
  projectValidationQueue: {
    title: 'Project Validation Queue',
    subtitle: 'Projects awaiting superuser approval before opening for bids',
    noPending: 'No projects pending approval',
    submittedOn: 'Submitted',
    reject: 'Reject',
    approve: 'Approve',
    viewDetails: 'View Details',
    rejectModalTitle: 'Reject Project',
    rejectModalHint: 'Tell the client why this project is being rejected so they know what to fix.',
    rejectReasonLabel: 'Rejection reason',
    rejectReasonPlaceholder:
      'e.g., Missing legal documents, budget seems unrealistic for the scope...',
    rejectModalCancel: 'Cancel',
    rejectModalConfirm: 'Confirm Rejection'
  },
  presetEditor: {
    title: 'Mini-Form Presets',
    subtitle:
      'Cards shown on the landing page, and the values each one prefills into the mini-form',
    previewLabel: 'Live preview',
    noPresets: 'No presets yet — add the first one',
    hidden: 'Hidden',
    addPreset: 'Add preset',
    newPreset: 'New preset',
    editPreset: 'Edit preset',
    edit: 'Edit',
    delete: 'Delete',
    moveUp: 'Move up',
    moveDown: 'Move down',
    slug: 'Slug',
    slugHint: 'Used in the URL, e.g. /mulai-proyek?preset=apartment',
    buildingFunction: 'Maps to category',
    projectScope: 'Project scope',
    subCategory: 'Sub-category',
    subCategoryNone: 'No sub-category',
    labelEn: 'Card label (EN)',
    labelId: 'Card label (ID)',
    eyebrowEn: 'Card eyebrow (EN)',
    eyebrowId: 'Card eyebrow (ID)',
    icon: 'Icon',
    image: 'Card image',
    imageHint: 'Shown on the landing page "Project types" card. JPG or PNG, landscape works best.',
    noImage: 'No image',
    removeImage: 'Remove image',
    defaultsLabel: 'Mini-form defaults',
    defaultsHint: 'Prefilled when someone opens the form from this card. Leave blank to skip.',
    defaultTitleEn: 'Default title (EN)',
    defaultTitleId: 'Default title (ID)',
    defaultLotSize: 'Default lot size (m²)',
    defaultDesignBudget: 'Default design budget (IDR)',
    defaultDescriptionEn: 'Default description (EN)',
    defaultDescriptionId: 'Default description (ID)',
    visible: 'Visible on landing page',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
    deleteTitle: 'Delete preset',
    deleteHint: 'This permanently removes the landing card',
    loadError: 'Failed to load presets',
    saveError: 'Failed to save preset',
    deleteError: 'Failed to delete preset',
    reorderError: 'Failed to reorder presets'
  },
  landingEditor: {
    title: 'Landing Page Editor',
    subtitle: 'Manage the hero carousel images and the review shown under each one',
    previewLabel: 'Live preview',
    noSlides: 'No slides yet — add the first one',
    noQuote: 'No review yet',
    hidden: 'Hidden',
    addSlide: 'Add slide',
    newSlide: 'New slide',
    editSlide: 'Edit slide',
    edit: 'Edit',
    delete: 'Delete',
    moveUp: 'Move up',
    moveDown: 'Move down',
    image: 'Image',
    chooseImage: 'Choose image',
    removeImage: 'Remove',
    imageHint: 'JPG, PNG, GIF or WebP · max 5MB',
    architectName: 'Architect / studio name',
    rating: 'Rating (0–5)',
    quote: 'Review quote',
    reviewerName: 'Reviewer name',
    verified: 'Show verified badge',
    visible: 'Visible on landing page',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
    deleteTitle: 'Delete slide',
    deleteHint: 'This permanently removes the image and review for'
  },
  superuserProjectDetail: {
    title: 'Project Detail',
    clientDetails: 'Client Details',
    clientDetailsHint: 'Use this to call the client and verify the project before approving it.',
    name: 'Name',
    email: 'Email',
    phone: 'Phone Number',
    phoneVerified: 'Verified',
    phoneUnverified: 'Not Verified',
    ktp: 'KTP Number',
    ktpVerified: 'Verified',
    ktpUnverified: 'Not Verified',
    notProvided: 'Not provided',
    reject: 'Reject',
    approve: 'Approve',
    rejectModalTitle: 'Reject Project',
    rejectModalHint: 'Tell the client why this project is being rejected so they know what to fix.',
    rejectReasonLabel: 'Rejection reason',
    rejectReasonPlaceholder:
      'e.g., Missing legal documents, budget seems unrealistic for the scope...',
    rejectModalCancel: 'Cancel',
    rejectModalConfirm: 'Confirm Rejection'
  },
  userManagement: {
    title: 'User Management',
    subtitle: 'View and manage platform users',
    colUser: 'User',
    colRoles: 'Roles',
    colStatus: 'Status',
    colJoined: 'Joined',
    statusActive: 'Active',
    statusDeactivated: 'Deactivated',
    deactivate: 'Deactivate',
    reactivate: 'Reactivate',
    page: 'Page',
    of: 'of',
    prev: 'Prev',
    next: 'Next',
    deactivateConfirm: 'Deactivate this user? They will not be able to log in.'
  },
  disputeManagement: {
    title: 'Dispute Management',
    subtitle: 'Resolve disputed phases between clients and architects',
    noDisputes: 'No active disputes',
    disputed: 'DISPUTED',
    maxRevisions: 'Max revisions:',
    used: 'Used:',
    resolutionNote: 'Resolution note (optional)',
    resolutionPlaceholder: 'Reason for your decision...',
    approveDeliverable: 'Approve Deliverable',
    rejectToProgress: 'Reject (Back to IN_PROGRESS)',
    cancel: 'Cancel',
    resolve: 'Resolve Dispute'
  },
  negotiationDisputes: {
    title: 'Negotiation Disputes',
    subtitle:
      'Review projects where the 7-day negotiation window expired without both parties confirming',
    noDisputes: 'No negotiation disputes',
    expired: 'EXPIRED',
    client: 'Client',
    architect: 'Architect',
    bidAmount: 'Bid Amount',
    acceptedOn: 'Accepted on',
    expiredOn: 'Expired on',
    resolutionNote: 'Resolution note (optional)',
    resolutionPlaceholder: 'Context for your decision...',
    clientAbandoned: 'Client Abandoned',
    architectAbandoned: 'Architect Abandoned',
    clientAbandonedHint: 'Refunds every bid on this project, including the winning bid.',
    architectAbandonedHint: 'Refunds every bid except the winning bid, which is forfeited.',
    cancel: 'Cancel',
    resolve: 'Resolve'
  },
  allProjectsAdmin: {
    title: 'All Projects',
    subtitle: 'Platform-wide project management',
    noProjects: 'No projects found',
    forceInProgress: 'Force IN_PROGRESS',
    forceCancel: 'Force Cancel',
    forceCancelConfirm: 'Force cancel this project?',
    forceProgressConfirm: 'Force this project to IN_PROGRESS, bypassing dual confirmation?',
    filterAll: 'All',
    filterPendingApproval: 'Pending Approval',
    filterOpen: 'Open',
    filterNegotiation: 'Negotiation',
    filterInProgress: 'In Progress',
    filterCompleted: 'Completed',
    filterCancelled: 'Cancelled'
  },
  clientMessages: {
    title: 'Messages',
    noConversations: 'No conversations yet',
    projectChat: 'Project Chat',
    noMessagesYet: 'No messages yet',
    selectConversation: 'Select a conversation',
    selectConversationHint: 'Choose a project chat from the list to start messaging.',
    typeMessage: 'Type a message...'
  },
  projectStatus: {
    DRAFT: 'Draft',
    PENDING_APPROVAL: 'Pending Validation',
    OPEN: 'Open',
    BIDDING_CLOSED: 'Bidding Closed',
    NEGOTIATION: 'Finalization',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    REJECTED: 'Rejected',
    CLOSED: 'Closed',
    AWARDED: 'Awarded',
    PENDING: 'Pending Validation',
    NEGOTIATION_EXPIRED: 'Finalization Expired',
    DELETED: 'Deleted'
  },
  bidStatus: {
    DRAFT: 'Draft',
    PENDING: 'Pending',
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    WITHDRAWN: 'Withdrawn'
  },
  iaiPicker: {
    examplesLabel: 'Examples',
    legacyNote:
      'These earlier entries have no equivalent in the IAI classification. They are kept on your profile but can no longer be selected.',
    selectedCount: 'selected',
    emptyHint: 'Open a category to choose the building types you work on.'
  },
  expertiseTagLabels: {
    Residential: 'Residential',
    Commercial: 'Commercial',
    Renovation: 'Renovation',
    'Sustainable Design': 'Sustainable Design',
    'Urban Planning': 'Urban Planning',
    'Interior Design': 'Interior Design',
    'Landscape Architecture': 'Landscape Architecture',
    'Historic Preservation': 'Historic Preservation',
    Institutional: 'Institutional',
    Industrial: 'Industrial',
    'Mixed-Use': 'Mixed-Use',
    Hospitality: 'Hospitality'
  },
  degreeLevelLabels: {
    S1: "S1 — Bachelor's Degree (Sarjana)",
    S2: "S2 — Master's Degree (Magister)",
    S3: 'S3 — Doctorate (Doktor/PhD)'
  },
  brief: {
    nav: {
      howItWorks: 'How it works',
      findArchitect: 'Find an architect',
      estimateCost: 'Cost estimate',
      login: 'Log in',
      cta: 'Create a project brief'
    },
    steps: {
      lineup: {
        title: 'Which services do you need?',
        subtitle: 'Choose one or more services.'
      },
      quick: {
        title: 'Describe your project',
        subtitle: ''
      }
    },
    lineup: {
      design: {
        label: 'Architectural design',
        desc: 'Building concept, space planning, working drawings and design visuals.'
      },
      build: {
        label: 'Construction',
        desc: 'Construction preparation, building works and project completion.'
      },
      craftsman: {
        label: 'Tradespeople and technicians',
        desc: 'For repairs or small-scale jobs.'
      },
      comingSoon: 'Coming soon',
      providerPrompt: 'Are you a service provider?',
      providerCta: 'Join here'
    },
    privacy: {
      badge: 'Your data is safe.',
      learnMore: 'Learn more',
      title: 'How we protect your data',
      close: 'Close',
      ok: 'Got it',
      points: [
        {
          title: 'Your phone number stays hidden',
          desc: 'An architect can only contact you after you accept their proposal.'
        },
        {
          title: 'Location is shown as an area',
          desc: 'Architects see the city or district. The exact pin and full address are shared once a contract is agreed.'
        },
        {
          title: 'Verified partners only',
          desc: 'Only architects who have passed rumantra verification can open your brief.'
        },
        {
          title: 'Never sold to third parties',
          desc: 'Your data is used to match your project with architects, not for advertising or third parties.'
        }
      ]
    },
    form: {
      title: 'Project Title',
      titlePlaceholder: 'e.g. Modern Family Home in Bandung',
      scope: 'Project Scope',
      scopeTips: {
        NEW_BUILD:
          'Constructing a new building on empty land or after an old building is demolished.',
        RENOVATION: 'Changing, repairing or extending an existing building.',
        INTERIOR_FIT_OUT:
          'Fitting out the inside of an existing building: finishes, furniture and lighting.',
        RESTORATION: 'Restoring an old or historic building while keeping its original character.'
      },
      category: 'Category',
      categoryPlaceholder: 'Choose a category',
      subCategory: 'Sub-category',
      subCategoryPlaceholder: 'Choose a sub-category',
      subCategoryDisabled: 'Choose a category first',
      location: 'Location',
      locationHint:
        'Search the address, then drag the pin or click the map to mark the exact site.',
      lotSize: 'Lot Size (m²)',
      lotSizePlaceholder: 'e.g. 200',
      buildArea: 'Building Area (m²)',
      buildAreaPlaceholder: 'e.g. 320',
      designFee: 'Design Budget (Architect Fee)',
      designFeePlaceholder: 'e.g. 150,000,000',
      designFeeHint:
        'IAI guideline: set a fair design fee for the scale and complexity of your project.',
      openCalculator: 'Open calculator',
      vision: 'What do you have in mind?',
      visionPlaceholder: 'Number of rooms, preferred style, target timeline — anything helps.',
      phone: 'Phone Number',
      phonePlaceholder: 'e.g. +62 812 3456 7890',
      phoneInvalid: 'Phone number must be 10–16 digits.',
      requiredError: 'This field is required.',
      start: 'Expected Start',
      startImmediately: 'As soon as possible',
      startSpecific: 'On a specific date'
    },
    actions: {
      back: 'Back',
      saveAndContinue: 'Save and continue',
      continue: 'Continue',
      submitting: 'Saving…',
      needService: 'Choose at least one service to continue',
      needFields: 'Still missing',
      submitError: 'Your brief was not saved. Please try again in a moment.'
    },
    calculator: {
      title: 'Find your ideal budget',
      subtitle: 'Click the design fee estimate to use it in the form.',
      workLabel: 'Type of work',
      workBaru: 'New build',
      workRenovasi: 'Renovation',
      budgetLabelBaru: 'Estimated construction budget',
      budgetLabelRenovasi: 'Estimated renovation budget',
      budgetHint:
        'Construction cost only, excluding land. Fill in the second field if you have a range.',
      minPlaceholder: 'Rp',
      maxPlaceholder: 'Rp (optional)',
      until: 'to',
      eyebrow: 'Estimated design fee',
      use: 'Use',
      useTitle: 'Use in the form',
      subtitle1: 'For architectural design up to working drawings.',
      subtitle2: 'Construction costs not included.',
      calcToggle: 'Calculation assumptions',
      calcBudget: 'Construction budget',
      calcScope: 'Service scope',
      calcScopeValue: 'Architectural design up to working drawings',
      calcCategory: 'Building category',
      renovationAdjustment: 'renovation adjustment',
      calcMethod: 'Method',
      calcMethodValue: 'IAI fee schedule, 2007 edition',
      fillBudget: 'Enter an estimated budget to see the estimate.',
      invalidRange: 'The second amount should be larger than the first.',
      disclaimer: 'Initial estimate. Final proposals depend on your needs and project scope.'
    },
    auth: {
      panelTitle: 'One account for all your projects.',
      panelSubtitle: 'The brief you filled in is saved automatically once you log in.',
      perks: [
        'Save your brief and continue any time',
        'Receive proposals from verified architects',
        'Manage contracts, progress and payments in one place'
      ],
      tabLogin: 'Log in',
      tabRegister: 'Sign up',
      loginTitle: 'Log in to rumantra',
      loginSubtitle: 'Use your existing account.',
      registerTitle: 'Create a new account',
      registerSubtitle: 'Free. It only takes a minute.',
      google: 'Continue with Google',
      linkedin: 'Continue with LinkedIn',
      orEmail: 'or with email',
      fullName: 'Full name',
      fullNamePlaceholder: 'e.g. Budi Santoso',
      email: 'Email',
      emailPlaceholder: 'e.g. budi@email.com',
      password: 'Password',
      passwordPlaceholder: 'Your password',
      newPasswordPlaceholder: 'At least 8 characters',
      passwordHint: 'Use at least 8 characters with uppercase, lowercase, a number and a symbol.',
      strength: ['Too weak', 'Weak', 'Fair', 'Strong', 'Very strong'],
      loginCta: 'Log in',
      registerCta: 'Create account',
      errEmail: 'Enter a valid email.',
      errPassword: 'Enter your password.',
      errName: 'Enter your full name.',
      errWeakPassword:
        'Password needs at least 8 characters with uppercase, lowercase, a number and a symbol (@#$%^&+=!_-).',
      errTerms: 'Accept the Terms and Conditions to continue.',
      errLogin: 'Incorrect email or password.',
      errRegister: 'Sign-up failed. Please try again.',
      errSocial: 'Could not connect. Please try again.',
      verifyTitle: 'Check your email',
      verifyBody:
        'We sent a verification link to {email}. Once your account is active, log in to continue your brief.',
      verifyCta: 'Back to log in',
      doneTitle: 'Signed in',
      doneBody: 'Your brief so far is saved to your account. Continue with the project details.',
      doneCta: 'Continue',
      close: 'Close'
    }
  }
}
